(function() {
  var $alerts, $nag_me_settings, $race_navigation, $race_tables_container, $tug_of_war_settings, ALERT_FADE_DELAY, ALERT_FADE_DURATION, ALERT_QUICK_FADE_DELAY, addChosen, addEventsToHint, addStrategyEvents, addViewAsParam, allStats, anonymous, baseStats, buildTree, checkSigninData, createBoolSelect, createConditionSelect, current_date, current_race_date, current_time, current_time_container, dashboard, data, date_slug, date_vals, defaultEventHandlers, edit_nag_me_template, enableNagSearch, enterNapDialog, entryStats, err, error1, example_calendar, example_days, extractJsonFromHTML, field, free_calendar, getHorseNameColumnWidth, getQueryDict, historyRenderer, initFrozenColumn, initPagination, initPopovers, initRaceUpdateRow, initTooltips, initTouchStyles, is_mobile, last_nap_update_requested_at, last_selection_requested_at, leaderboard, nagMeNoteCounter, napPicksChange, raceRenderer, raceUpdater, race_date_str, ravenInfo, renderNagMes, resetHints, resizeHorseNameColumn, saveNapPicks, saveSigninData, scheduleSigninCheck, scroll_to_race_anchor, selectionStats, showAlert, showClearNotificationsAlert, showDialog, showMobilePresetDialog, showModal, showSigninDialog, show_confirm_dialog, show_nag_me_dialog, stats_mode, stompMonitor, strategy_tree, tableSorter, tree, treeToJson, updateFrozenElement, updateFrozenElementBackground, updateFrozenElementBackgroundIn, updateFrozenElementBackgroundOut, updateFrozenElementMobile, updateToggler, update_nag_me_count, val, viewAsURL, view_as, windowIsHidden, windowIsShown,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  ravenInfo = $("#raven-info");

  if (ravenInfo.data("project") !== "") {
    Raven.config('https://' + ravenInfo.data("key") + '@sentry.io/' + ravenInfo.data("project")).install();
    Raven.setUserContext({
      id: ravenInfo.data("user-id"),
      username: ravenInfo.data("user-username"),
      name: ravenInfo.data("user-name"),
      email: ravenInfo.data("user-email")
    });
  }

  try {
    view_as = new URLSearchParams(window.location.search).get("viewas");
  } catch (error1) {
    err = error1;
    view_as = null;
  }

  viewAsURL = function(url) {
    var sep;
    if (url && !url.startsWith("http") && indexOf.call(url, "viewas=") < 0) {
      if (indexOf.call(url, "?") >= 0) {
        sep = "&";
      } else {
        sep = "?";
      }
      url += sep + "viewas=" + view_as;
    }
    return url;
  };

  addViewAsParam = function($element) {
    if (!view_as || !$element || !$element.find) {
      return;
    }
    return $element.find("a[href]").each(function(i, item) {
      var $item, url;
      $item = $(item);
      url = $item.attr("href");
      return $item.attr("href", viewAsURL(url));
    });
  };

  $.toFixed = function(num, precision) {
    return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
  };

  $.getOrdinal = function(n) {
    var s, v;
    s = ["th", "st", "nd", "rd"];
    v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  $.toGBP = function(value) {
    if (value != null) {
      return "£&thinsp;" + ($.toFixed(value, 2));
    } else {
      return "";
    }
  };

  $.toPercentage = function(value, precision) {
    if (precision == null) {
      precision = 2;
    }
    if (value != null) {
      return ($.toFixed(value * 100, precision)) + "%";
    } else {
      return "";
    }
  };

  $.colourAE = function(value) {
    var result;
    result = "white";
    if (value > 1) {
      result = "lime";
    } else if (value < 1) {
      result = "orangered ";
    }
    return result;
  };

  $.colourProfitAndLoss = function(value) {
    var result;
    result = "white";
    if (value > 0) {
      result = "lime";
    } else if (value < 0) {
      result = "orangered";
    }
    return result;
  };

  $.colourROI = function(value) {
    return $.colourProfitAndLoss(value);
  };

  windowIsHidden = function() {
    return document.hidden || document.msHidden || document.webkitHidden;
  };

  windowIsShown = function() {
    return !windowIsHidden();
  };

  $.profitAndLossClass = function(value) {
    if (value < 0) {
      return "losings";
    } else if (value > 0) {
      return "winnings";
    } else {
      return "";
    }
  };

  $.toUserTimeZone = function(value) {
    var server_time, server_tz, user_time, user_tz;
    if (value != null) {
      server_tz = "Europe/London";
      server_time = moment.tz(moment().format("YYYY-MM-DD") + " " + value, server_tz);
      user_tz = moment.tz.guess();
      if (server_tz !== user_tz) {
        user_time = server_time.clone().tz(user_tz);
        return "/ " + user_time.format("HH:mm z");
      }
    }
    return "";
  };

  getQueryDict = function() {
    var query_dict;
    query_dict = {};
    location.search.substr(1).split("&").forEach(function(item) {
      var kv;
      kv = item.split("=");
      return query_dict[kv[0]] = kv[1];
    });
    return query_dict;
  };

  extractJsonFromHTML = function(id) {
    var element, json;
    element = $(id);
    json = element.text();
    if (!json) {
      return {};
    }
    element.remove();
    return JSON.parse(json);
  };

  Opentip.styles.defaultStyle = {
    fixed: true,
    "extends": "dark"
  };

  Opentip.defaultStyle = "defaultStyle";

  initTooltips = function($element) {
    var $all_tipped, i, timer;
    addViewAsParam($element);
    if (!$.rtrApp["tooltips"]) {
      $.rtrApp["tooltips"] = [];
      $(window, document, "div#race-tables").scroll(function() {
        var l, len, ref, results, tt;
        ref = $.rtrApp["tooltips"];
        results = [];
        for (l = 0, len = ref.length; l < len; l++) {
          tt = ref[l];
          results.push(tt.hide());
        }
        return results;
      });
    }
    if ($.rtrApp["is_touch_device"]) {
      $all_tipped = $element.find('th[data-title], td.stat div[data-title], td.r div span[data-title]');
    } else {
      $all_tipped = $element.find('[data-title], [data-ajax]');
    }
    Opentip.lastZIndex = 10000;
    i = 0;
    return timer = setInterval(function() {
      var $tipped, _, l, results, tipped, tt;
      results = [];
      for (_ = l = 1; l <= 20; _ = ++l) {
        tipped = $all_tipped[i++];
        if (tipped) {
          $tipped = $(tipped);
          if ($tipped.hasClass("silks")) {
            tt = new Opentip($tipped, "<img class='large-silks' src='" + ($tipped.find("img").attr("src")) + "'/>" + ($tipped.data("title")));
          } else if ($tipped.data("template-file")) {
            tt = new Opentip($tipped, window.HAML[$tipped.data("template-file")]($tipped.data("template-context")));
          } else if ($tipped.data("ajax")) {
            tt = new Opentip($tipped, {
              ajax: $tipped.data("ajax")
            });
          } else {
            tt = new Opentip($tipped, $tipped.data("title"));
          }
          if ($.rtrApp["tooltips"]) {
            results.push($.rtrApp["tooltips"].push(tt));
          } else {
            results.push(void 0);
          }
        } else {
          results.push(clearInterval(timer));
        }
      }
      return results;
    }, 100);
  };

  initTooltips($("body"));

  initPopovers = function(element) {
    return element.find('[data-popover-href]:not([data-popover-href=""])').hover(function() {
      return $(this).toggleClass("hover");
    }).mouseenter(function() {
      var popover;
      popover = $(this);
      popover.off("mouseenter");
      return $.get(popover.data('popover-href')).done(function(data) {
        popover.popover({
          content: data.body,
          title: data.title,
          html: true,
          container: "body",
          trigger: "hover",
          placement: "bottom"
        });
        if (popover.hasClass("hover")) {
          return popover.popover("show");
        }
      });
    });
  };

  initPopovers($("body"));

  is_mobile = $("body").data("is-mobile") === "True";

  $("#show-toolbar").click(function() {
    var toolbar;
    toolbar = $('#toolbar');
    return toolbar.toggle();
  });

  $('#download-button').on("click", function(event) {
    var filterset;
    this.filterList = $('.current-data-filtersets-list');
    filterset = [];
    $('.current-data-filtersets-list');
    if (this.filterList.length) {
      this.filterList.each(function(index, search) {
        return filterset.push(search.innerText);
      });
    }
    return $.post(this.dataset.url, {
      filtersets: JSON.stringify(filterset)
    }).done(function(data) {
      var a, contentType, csvFile, dateInfo, regExp;
      window.URL = window.webkitURL || window.URL;
      contentType = 'text/csv';
      csvFile = new Blob([data], {
        type: contentType
      });
      regExp = /[12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])/;
      dateInfo = data.match(regExp);
      a = document.createElement('a');
      a.download = 'rtr_filtersets_results_' + dateInfo[0] + '.csv';
      a.href = window.URL.createObjectURL(csvFile);
      a.dataset.downloadurl = [contentType, a.download, a.href].join(':');
      a.click();
      return a.remove();
    }).error(function(error) {
      return console.error(error);
    });
  });

  $(window).on('resize', function() {
    if (!$("#show-toolbar").is(":visible")) {
      return $('#toolbar').show();
    }
  });

  initTouchStyles = function() {
    var is_touch_device, style;
    is_touch_device = indexOf.call(document.documentElement, 'ontouchstart') >= 0 || navigator.userAgent.search(/Touch|Android|iPad|iPhone|iPod|iWatch/i) !== -1;
    if (is_touch_device) {
      $('#races-font-size').removeClass("hidden").find("button").each(function(_, item) {
        var $button;
        $button = $(item);
        if ($button.hasClass("btn-info")) {
          $race_tables_container.children().css("font-size", $button.css("font-size"));
          return false;
        }
      }).click(function() {
        var $button;
        $button = $(this);
        $button.parent().find(".btn-info").removeClass("btn-info").addClass("btn-primary");
        $button.addClass("btn-info");
        $race_tables_container.children().css("font-size", $button.css("font-size"));
        return $.ajax({
          method: "PUT",
          url: "/members/",
          data: {
            "mobile-font-size": $button.attr("font-size-name")
          }
        });
      });
      style = ".tooltip .tooltip-inner:after {\n  content: ' (Tap to close)'\n}";
    } else {
      $(".table-responsive:not(.always-responsive)").removeClass("table-responsive");
      style = "tr.runner:hover td.hover {\n  background: url(/static/images/gradhover3.png) #74ff71;\n  background-size: 100% 100%;\n}";
    }
    style = $("<style type='text/css'>\n" + style + "\n</style>");
    return style.appendTo($(document.head));
  };

  ALERT_FADE_DELAY = 15000;

  ALERT_QUICK_FADE_DELAY = 1500;

  ALERT_FADE_DURATION = 1000;

  $alerts = $("#alerts");

  $alerts.on("click", ".authorise-twitter", function(event) {
    if (anonymous.isAnonymous()) {
      anonymous.showUpgradeDialog("access Free Friday by authorising Twitter", "Free");
      return event.preventDefault();
    }
  });

  showAlert = function(type, message, fades_out, quick) {
    var $alert, delay, fades_out_class, notification;
    if (quick == null) {
      quick = false;
    }
    delay = quick ? ALERT_QUICK_FADE_DELAY : ALERT_FADE_DELAY;
    notification = parseInt($('body').data('notifications-setting'));
    if (isNaN(notification) || notification < 0) {
      return;
    }
    fades_out_class = fades_out ? 'fades-out' : '';
    $alert = $("<div class=\"alert alert-dismissable alert-" + type + " " + fades_out_class + "\">\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button>\n  <span class=\"sr-only\">" + (type[0].toUpperCase()) + (type.substring(1)) + "</span>\n  " + message + "\n</div>");
    $alerts.prepend($alert);
    if (fades_out) {
      $alert.delay(delay).fadeOut(ALERT_FADE_DURATION, function() {
        return $alert.remove();
      });
    }
    return showClearNotificationsAlert();
  };

  showClearNotificationsAlert = function() {
    var $alert, notification;
    notification = parseInt($('body').data('notifications-setting'));
    if (isNaN(notification) || notification < 0) {
      return;
    }
    $('#clear-notifications').closest('.alert-info').remove();
    if ($alerts.find(".alert:not(.fades-out)").length > 1) {
      $alert = $("<div class=\"alert alert-dismissable alert-info\">\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button>\n  <button id=\"clear-notifications\" class=\"btn btn-info\">Clear Notifications</button>\n</div>");
      $alerts.prepend($alert);
      return $alert.find("#clear-notifications").click(function() {
        return $alerts.empty();
      });
    }
  };

  current_time_container = $("#current-time");

  current_time = current_time_container.find("span.time");

  current_date = current_time_container.find("span.date");

  setInterval(function() {
    var now;
    now = moment().tz("Europe/London");
    current_time.text(now.format("HH:mm"));
    return current_date.text(now.format("dddd MMMM D, YYYY"));
  }, 1000);

  $(".profile.card-toggler").on('click', function() {
    var body, item_id, spinner, toggler;
    toggler = $(this);
    item_id = toggler.attr("item-id");
    body = $(".toggle-" + item_id);
    if (body.html()) {
      updateToggler(toggler, false);
      return body.slideUp("fast", function() {
        return body.html("");
      });
    } else if (!body.prop("loading")) {
      body.prop("loading", true);
      spinner = $("<i class='glyphicon glyphicon-refresh' />").appendTo(toggler.parent());
      updateToggler(toggler, true);
      return $.get("body/" + item_id + "/").done(function(data) {
        body.append(data);
        body.prop("loading", false);
        body.slideDown("fast");
        return spinner.remove();
      });
    }
  });

  updateToggler = function(toggler, is_open) {
    var new_class, old_class;
    if (is_open) {
      old_class = "glyphicon-triangle-right";
      new_class = "glyphicon-triangle-bottom";
    } else {
      old_class = "glyphicon-triangle-bottom";
      new_class = "glyphicon-triangle-right";
    }
    return toggler.removeClass(old_class).addClass(new_class);
  };

  showDialog = function(data) {
    var dialog;
    dialog = $("#modal");
    dialog.find(".modal-content").html(data);
    initTooltips(dialog);
    dialog.modal("show");
    return dialog;
  };

  showModal = function(data) {
    var dialog;
    dialog = $("#modal");
    dialog.find(".modal-content").html(data);
    initTooltips(dialog);
    dialog.modal({
      show: "true",
      backdrop: "static",
      keyboard: false
    });
    return dialog;
  };

  show_confirm_dialog = function(text, success_callback, ok_text, cancel_text) {
    var dialog, modal;
    if (ok_text == null) {
      ok_text = "Delete";
    }
    if (cancel_text == null) {
      cancel_text = 'Cancel';
    }
    success_callback = success_callback || function() {};
    modal = "<div id=\"confirm-modal\" class=\"modal\" aria-labelledby=\"Dialog\" aria-hidden=\"true\" role=\"dialog\" tabindex=\"-1\">\n<div class=\"modal-dialog\">\n<div class=\"modal-content\">\n  <div class=\"modal-header\">\n  <div class=\"modal-title h1\">\n      Confirm Action\n  </div>\n  </div>\n  <div class=\"modal-body\">\n      " + text + "\n  </div>\n  <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">" + cancel_text + "</button>\n      <a class=\"btn btn-danger btn-ok\" id=\"confirm-delete\" data-dismiss=\"modal\">" + ok_text + "</a>\n  </div>\n</div></div></div>";
    dialog = $(modal);
    initTooltips(dialog);
    dialog.modal("show");
    dialog.find('#confirm-delete').on('click', function() {
      return success_callback();
    });
    return dialog;
  };

  tableSorter = {
    dir: 'asc',
    page: 1,
    trackMixpanel: function(action, params) {
      var that;
      return that = this;
    },
    updateIcons: function() {
      var direction_icon, sorters;
      sorters = this.$table.find("thead .sortable");
      sorters.removeClass("glyphicon-chevron-up").removeClass("glyphicon-chevron-down").addClass("glyphicon-minus");
      direction_icon = "glyphicon-chevron-" + (this.dir === "asc" ? "down" : "up");
      return sorters.filter("[data-column=" + this.column + "]").removeClass("glyphicon-minus").addClass(direction_icon).data("dir", this.dir);
    },
    paginate: function(num_pages) {
      var $html;
      if (num_pages > 1) {
        $html = window.HAML["rating_the_races/client/templates/pagination"]({
          page: this.page,
          num_pages: num_pages
        });
      } else {
        $html = '';
      }
      this.$pagination.html($html);
      return initTooltips(this.$pagination);
    },
    initSortIcons: function() {
      var that;
      that = this;
      this.$table.find("thead .sortable").click(function() {
        var $icon;
        $icon = $(this);
        if ($icon.data("column") === that.column) {
          that.dir = $icon.data("dir") === "asc" ? "desc" : "asc";
        } else {
          that.dir = $icon.data("default-dir") || "asc";
          that.column = $icon.data("column");
        }
        that.trackMixpanel("sorted", {
          dir: that.dir,
          column: that.column
        });
        return that.load();
      });
      return this.updateIcons();
    },
    initPagination: function() {
      var that;
      that = this;
      return this.$pagination.on("click", "button:not(.active):not(.disabled)", function() {
        that.page = $(this).data("page");
        that.trackMixpanel("paginated", {
          page: that.page
        });
        return that.load();
      });
    },
    load: function(url, extra_data, force_filterset) {
      var data, that;
      if (url == null) {
        url = null;
      }
      if (extra_data == null) {
        extra_data = null;
      }
      if (force_filterset == null) {
        force_filterset = false;
      }
      that = this;
      if (this.is_loading) {
        return;
      }
      this.$table.find("tbody").html('<tr><td colspan=100>Loading... <i class="glyphicon glyphicon-refresh black" /></td></tr>');
      if (url == null) {
        url = this.load_url(force_filterset);
      }
      data = this.load_data(url);
      if (extra_data != null) {
        $.extend(data, extra_data);
      }
      return $.ajax({
        method: this.override_method ? this.override_method() : "GET",
        url: url,
        data: data
      }).done(function(data) {
        return that.update(data);
      }).always(function() {
        return that.is_loading = false;
      }).error(function() {
        return that.$table.find("tbody").html('<tr><td colspan=100>Error - unable to update...</div></td></tr>');
      });
    }
  };

  anonymous = {
    upgradeDialogURL: $('body').data("requires-upgrade-dialog-url"),
    isAnonymous: function() {
      return $('body').data("is-anonymous");
    },
    showUpgradeDialog: function(reason, minimum_membership) {
      $.rtrApp.trackMixpanel("Showed upgrade dialog");
      return $.ajax({
        method: "GET",
        url: this.upgradeDialogURL,
        data: {
          reason: reason,
          redirect: window.location.href,
          minimum_membership: minimum_membership
        }
      }).done(function(data) {
        return showDialog(data);
      }).fail(function() {
        return showAlert("danger", "Failed to get dialog to encourage upgrade to " + minimum_membership, true);
      });
    }
  };

  $tug_of_war_settings = $("#tug-of-war-settings");

  showSigninDialog = function() {
    if (anonymous.isAnonymous()) {
      return;
    }
    $('#loading-indicator').show();
    return $.get($tug_of_war_settings.data("dialog-url")).done(function(data) {
      var $dialog, $yes_button;
      $dialog = showModal(data);
      $yes_button = $dialog.find('.confirm');
      return $yes_button.on('click', function() {
        saveSigninData();
        return $dialog.modal('hide');
      });
    }).always(function() {
      return $('#loading-indicator').hide();
    });
  };

  checkSigninData = function() {
    if (anonymous.isAnonymous()) {
      return;
    }
    if ($("div.modal-body.signin:visible").length > 0) {
      return;
    }
    return $.ajax({
      method: "GET",
      url: $tug_of_war_settings.data("check-url")
    }).done(function(response) {
      if (response.message === "FAILURE") {
        return showSigninDialog();
      }
    }).fail(function() {
      return showSigninDialog();
    });
  };

  saveSigninData = function() {
    return $.ajax({
      method: "GET",
      url: $tug_of_war_settings.data("save-url")
    });
  };

  scheduleSigninCheck = function() {
    return setInterval((function() {
      return checkSigninData();
    }), 30000);
  };

  if (!anonymous.isAnonymous()) {
    scheduleSigninCheck();
  }

  jQuery.ajaxSettings.traditional = true;

  if (view_as) {
    $.ajaxSetup({
      data: {
        viewas: view_as
      }
    });
  }

  $(document).ajaxSend(function(event, xhr, ajaxOptions) {
    return xhr.setRequestHeader('X-CSRFToken', Cookies.get('csrftoken'));
  });

  leaderboard = {
    is_loading: false,
    $pagination: $("#leaderboard-pagination"),
    $table: $("#leaderboard-table"),
    column: $("#leaderboard-table").data("default-column"),
    future_events_html: null,
    load_url: function() {
      return "?data=1";
    },
    load_data: function(url) {
      var params;
      params = {
        page: this.page,
        column: this.column,
        dir: this.dir
      };
      return params;
    },
    update: function(data) {
      var $body;
      $body = $(window.HAML["leaderboards/client/templates/body"](data));
      $body.hide();
      this.$table.find("tbody").html($body);
      initTooltips($body);
      initPopovers($body);
      this.updateIcons();
      if (data["settings"]["num_pages"] != null) {
        this.paginate(data["settings"]["num_pages"]);
      }
      $body.fadeIn("fast");
      return $("#updated-at").text(data.updated_at);
    },
    initSelection: function() {
      return $(".leaderboard").on("click", "td", function(event) {
        var $statisticsRow;
        $statisticsRow = $(this).closest("tr");
        if ($(event.target).is("a")) {
          return;
        }
        return $statisticsRow.toggleClass("selected");
      });
    },
    init: function() {
      var $future_events, that;
      that = this;
      $.extend(this, tableSorter);
      if ($('#default-leaderboard-period').length === 0) {
        return;
      }
      this.trackMixpanel = function(action, params) {
        var error2, leaderboard_type;
        try {
          leaderboard_type = window.location.pathname.split('/')[2];
        } catch (error2) {
          leaderboard_type = "unknown";
        }
        return $.rtrApp.trackMixpanel("Leaderboard " + action, $.extend({
          type: leaderboard_type
        }, params));
      };
      $future_events = $("[data-future-events-dialog-url]");
      if ($future_events.length === 1) {
        $future_events.click(function() {
          if (that.future_events_html) {
            showDialog(that.future_events_html);
            return;
          }
          $future_events.addClass("disabled");
          return $.get($future_events.data("future-events-dialog-url")).done(function(data) {
            that.future_events_html = data;
            return showDialog(data);
          }).fail(function() {
            return showAlert("danger", "Unable to retrieve list of upcoming events", true);
          }).always(function() {
            return $future_events.removeClass("disabled");
          });
        });
      }
      this.trackMixpanel("loaded");
      this.initSortIcons();
      this.initPagination();
      this.initSelection();
      return this.load();
    }
  };

  leaderboard.init();

  baseStats = {
    column: "title",
    is_loading: false,
    selectedField: '',
    $pagination: $("#stats-pagination"),
    is_filterset: $("#filterset").length,
    $group_by: $("#stats-group-by"),
    $filters: $("#stats-filters .filter"),
    $date_pickers: $("#stats-filters input.date"),
    $field_title: null,
    $current_filters: $("#current-filters"),
    $current_data_filters: $("#current-data-filters"),
    $current_table_filters: $("#current-table-filters"),
    $rows_to_filters_button: $('#stats-rows-to-filters'),
    $stats_filter_today: $('#stats-filter-today'),
    $stats_filter_tomorrow: $('#stats-filter-tomorrow'),
    $user_filters: $('#stats-user-filters'),
    $chart_filter_set_label: $('#stats-chart-filter-set-label'),
    initTable: function() {
      var $stats_filters, minimim_membership_to_filter;
      $.extend(this, tableSorter);
      this.trackMixpanel = function(action, params) {
        return $.rtrApp.trackMixpanel("Stats " + action, params);
      };
      this.$field_title = this.$table.find($(".field-title"));
      this.$filter_items = this.$filters.find("input, select");
      $stats_filters = $('#stats-filters');
      minimim_membership_to_filter = $stats_filters.data("minimum-membership");
      if (!minimim_membership_to_filter) {
        this.setDefaultFilters();
        this.initRowsToFilters();
        this.initFilterDay();
      }
      this.initSortIcons();
      this.initPagination();
      this.initDatePickers();
      this.initCharts();
      this.initSelection();
      if (minimim_membership_to_filter) {
        return $stats_filters.on("click", ".locked", function() {
          return anonymous.showUpgradeDialog("filter these stats", minimim_membership_to_filter);
        });
      }
    },
    initCharts: function() {
      var EXTRA_DATA, EXTRA_TITLES, chart, cloneToolTipOne, cloneToolTipTwo, that;
      that = this;
      EXTRA_TITLES = ["Run P&L", "Date", "Course", "Distance", "Horse", "Jockey", "Trainer"];
      EXTRA_DATA = ["run_p_and_l", "start_time", "race__track__course__name", "race__distance_furlongs", "horse__name", "jockey__name", "trainer__name"];
      if (typeof Highcharts === "undefined") {
        return;
      }
      cloneToolTipOne = null;
      cloneToolTipTwo = null;
      chart = new Highcharts.Chart({
        chart: {
          type: "line",
          renderTo: "stats-chart"
        },
        title: {
          text: "Historical P&L"
        },
        xAxis: {
          labels: {
            enabled: false
          }
        },
        yAxis: {
          plotBands: [
            {
              from: -9999,
              to: 0,
              color: "rgba(255, 0, 0, 0.1)"
            }, {
              from: 0,
              to: 9999,
              color: "rgba(0, 0, 0, 0)"
            }
          ],
          title: {
            text: "GBP"
          }
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
            cursor: "pointer",
            point: {
              events: {
                click: function() {
                  if (this.hasOwnProperty("url_path")) {
                    return window.open(window.location.origin + this.url_path, "_blank");
                  }
                }
              }
            }
          },
          spline: {
            marker: {
              enabled: false
            }
          }
        },
        tooltip: {
          useHTML: true,
          shared: true,
          formatter: function() {
            var point, result;
            point = this.points[0].point;
            if (!point.hasOwnProperty("_disable_tooltip")) {
              result = "<table width='200px'> <tr><td><b>Run P&L</b></td><td style='text-align: right'>" + point.run_p_and_l + " pts</td></tr> <tr><td><b>P&L</b></td><td style='text-align: right'>" + point.p_and_l + " pts</td></tr> <tr><td><b>Date</b></td><td style='text-align: right'>" + point.start_time + "</td></tr>";
              if (!point.hasOwnProperty("_is_big_series")) {
                result += "<tr><td><b>Course</b></td><td style='text-align: right'>" + point.race__track__course__name + "</td></tr> <tr><td><b>Distance</b></td><td style='text-align: right'>" + point.race__distance_furlongs + " furlongs</td></tr> <tr><td><b>Horse</b></td><td style='text-align: right'>" + point.horse__name + "</td></tr> <tr><td><b>Jockey</b></td><td style='text-align: right'>" + point.jockey__name + "</td></tr> <tr><td><b>Trainer</b></td><td style='text-align: right'>" + point.trainer__name + "</td></tr>";
              }
              result += "</table>";
              if (!point.hasOwnProperty("_is_big_series")) {
                result += "<br> <em><small>Click the point to get race opened in a new tab</small></em>";
              }
              return result;
            } else {
              return false;
            }
          },
          valueDecimals: 2
        },
        series: [
          {
            data: [],
            name: "Historical P&L"
          }
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                {
                  textKey: 'downloadCSV',
                  onclick: function() {
                    var csv, d, f, idx, is_boosted, l, len, len1, o, ref, row, rows;
                    is_boosted = !this.series[0].points[1].hasOwnProperty("start_time");
                    if (!is_boosted) {
                      csv = chart.getCSV();
                    } else {
                      rows = [];
                      rows.push(["Event", "Historical P&L"].concat(EXTRA_TITLES));
                      idx = 0;
                      ref = that.ajax_data['series'];
                      for (l = 0, len = ref.length; l < len; l++) {
                        d = ref[l];
                        row = [idx++, d.y];
                        for (o = 0, len1 = EXTRA_DATA.length; o < len1; o++) {
                          f = EXTRA_DATA[o];
                          row = row.concat(d[f]);
                        }
                        rows.push(row);
                      }
                      csv = chart.getCSV(rows);
                    }
                    return saveAs(new Blob([csv], {
                      type: "text/plain;charset=utf-8"
                    }), "chart.csv");
                  }
                }, {
                  textKey: 'downloadJPEG',
                  onclick: function() {
                    return this.exportChart({
                      type: 'image/jpeg'
                    });
                  }
                }
              ]
            }
          },
          csv: {
            extra_point_titles: EXTRA_TITLES,
            extra_point_data: EXTRA_DATA
          }
        }
      });
      this.chart = chart;
      this.ajax_data = void 0;
      return $("table.statistics").on("click", "td.chart", function() {
        var extra_data_key, obj, title_cell;
        $("#stats-chart-wrapper").css("height", "400px");
        obj = $(this);
        baseStats.hideChart();
        title_cell = obj.siblings().first();
        $("#stats-chart-loader").removeClass("hidden");
        $("#stats-chart-error").addClass("hidden");
        extra_data_key = obj.data("extra-data-key");
        if (!obj.parent().hasClass("total")) {
          that.trackMixpanel("Chart loaded", {
            data_key: extra_data_key
          });
        } else {
          that.trackMixpanel("Total chart loaded", {
            data_key: extra_data_key
          });
        }
        return $.get("/stats/extra_data/bfsp/" + extra_data_key + "/", {
          filter_set: that.$user_filters.find(".dropdown-toggle").text().trim()
        }).done(function(data) {
          var stats_div;
          that.ajax_data = data;
          if (that.chart.series && that.chart.series.length > 0) {
            that.chart.series[0].remove();
          }
          stats_div = $("#stats-chart");
          $("#stats-chart-loader").addClass("hidden");
          try {
            that.chart.addSeries({
              color: "#009000",
              data: data["series"],
              name: "Historical P&L",
              marker: {
                symbol: "circle"
              }
            });
            that.chart.xAxis[0].removePlotLine('created-filter-set');
            if (data["created_at"]["value"]) {
              that.chart.xAxis[0].addPlotLine({
                color: 'blue',
                width: 1,
                value: data["created_at"]["value"],
                id: 'created-filter-set'
              });
              that.$chart_filter_set_label.show().find(".date").text(data["created_at"]["date"]);
            } else {
              that.$chart_filter_set_label.hide();
            }
            if (stats_div.hasClass("chart-inactive")) {
              stats_div.show().removeClass("chart-inactive");
            }
            return that.chart.reflow();
          } catch (undefined) {}
        }).fail(function(xhr) {
          var data;
          data = xhr.responseJSON;
          if (data.message) {
            $("#stats-chart-error span.message").html(data.message);
          }
          return $("#stats-chart-error").removeClass("hidden");
        }).always(function() {
          return $("#stats-chart-loader").addClass("hidden");
        });
      });
    },
    hideChart: function() {
      $("#stats-chart").hide().addClass("chart-inactive");
      $("#stats-chart-loader").addClass("hidden");
      return $("#stats-chart-error").addClass("hidden");
    },
    initSelection: function() {
      var that;
      that = this;
      return $(".statistics").on("click", "td", function(event) {
        var $statisticsRow;
        $statisticsRow = $(this).closest("tr");
        if ($(event.target).hasClass("chart") || $(event.target).is("i")) {
          return;
        }
        $statisticsRow.toggleClass("selected");
        return that.updateRowsToFilterButton();
      });
    },
    addOrExtendFilter: function(filter_label, name, value, value_label, $filter, is_unique) {
      var $current_filter, already_in_filter;
      $current_filter = this.findFilter(name);
      if ($current_filter.length > 0) {
        already_in_filter = $current_filter.find("[data-value=\"" + value + "\"]").length > 0;
        if (already_in_filter) {
          return;
        }
        if (is_unique) {
          $current_filter.find(".value").remove();
        }
        return this.addFilterValue($current_filter, value, value_label);
      } else {
        return this.addFilter(filter_label, name, value, value_label, $filter);
      }
    },
    initGroupBy: function() {
      var that;
      that = this;
      return this.$group_by.find("a").click(function() {
        var $current_filter, $selection;
        $selection = $(this);
        that.$filters.removeClass("current");
        that.$group_by.data("value", $selection.data("value"));
        that.$group_by.find(".label").text($selection.text());
        $current_filter = that.$filters.filter("[data-filter=" + ($selection.data("value")) + "]");
        $current_filter.addClass("current");
        that.$current_table_filters.html("");
        that.page = 1;
        return that.load(null, null, false);
      });
    },
    setDataFilterSetTitle: function(name) {
      var $button;
      if (name == null) {
        name = null;
      }
      $button = this.$user_filters.find(".dropdown-toggle");
      if ($button.data("opentips")) {
        $button.data("opentips")[0].setContent("Current data filter set: " + (name || '&lt;unset&gt;'));
      }
      $button.find(".label").html(name || "&nbsp;");
      return this.updateUserFilterButtons();
    },
    getDataFilterSetTitle: function() {
      return this.$user_filters.find(".dropdown-toggle .label").text().trim();
    },
    removeFilterSet: function(name) {
      var $user_filter, filterLink, l, len, ref, user_filter;
      ref = this.$user_filters.find("li");
      for (l = 0, len = ref.length; l < len; l++) {
        user_filter = ref[l];
        $user_filter = $(user_filter);
        if ($user_filter.text().trim() === name) {
          $user_filter.remove();
          break;
        }
      }
      if (this.$user_filters.find("li").length === 1) {
        filterLink = document.querySelector('.filter-all-button');
        filterLink.setAttribute("disabled", "disabled");
        return filterLink.removeAttribute("href");
      }
    },
    filterSetExists: function(name) {
      var l, len, ref, user_filter;
      ref = this.$user_filters.find("li");
      for (l = 0, len = ref.length; l < len; l++) {
        user_filter = ref[l];
        if ($(user_filter).text().trim() === name) {
          return true;
        }
      }
      return false;
    },
    initUserFilters: function() {
      var that;
      that = this;
      this.$user_filters.on("click", "a", function() {
        var $selection, name;
        $selection = $(this);
        name = $selection.text().trim();
        that.setDataFilterSetTitle(name);
        that.selectedField = $selection.text().trim();
        if (name === "Default") {
          return that.setDefaultFilters(true);
        } else {
          return $.get(that.$user_filters.find(".dropdown-toggle").data("url").replace("NAME", encodeURIComponent(name))).done(function(data) {
            that.initFilters(data.filters, true);
            return that.trackMixpanel("data filter set selected", {
              name: name,
              filters: data.filters
            });
          });
        }
      });
      this.$user_filters.find("[data-action=delete]").click(function() {
        var filters, name, url;
        name = that.$user_filters.find(".dropdown-toggle").text().trim();
        url = $(this).data("url").replace("NAME", encodeURIComponent(name));
        filters = that.exportFilters(that.$current_data_filters);
        return show_confirm_dialog("Really delete data filter set named " + name + "?", function() {
          return $.ajax({
            method: "DELETE",
            url: url
          }).done(function() {
            showAlert("success", "Deleted data filter set: " + name, true);
            that.removeFilterSet(name);
            that.setDefaultFilters();
            that.updateUserFilterButtons();
            return that.trackMixpanel("data filter set deleted", {
              name: name,
              filters: filters
            });
          }).error(function() {
            return showAlert("danger", "Failed to delete data filter set");
          });
        });
      });
      this.$user_filters.find("[data-action=add]").click(function() {
        var $dialog, html, url;
        url = $(this).data('url');
        html = window.HAML["stats/client/templates/add_user_filters_dialog"]({
          max_name_length: that.$user_filters.data("max-name-length")
        });
        $dialog = showDialog(html);
        $dialog.find("#stats-filter-name").on("input", function() {
          return $dialog.find("[data-action=add]").prop("disabled", $(this).val().trim().length === 0);
        });
        return $dialog.find("[data-action=add]").click(function() {
          var filters, name;
          name = $dialog.find("#stats-filter-name").val().trim();
          $dialog.modal("hide");
          filters = that.exportFilters(that.$current_data_filters);
          if (that.filterSetExists(name)) {
            show_confirm_dialog("You already have a data filter set named '" + name + "'. You may replace it with the current filters if you wish.", function() {
              return that.createFilterSet(name, filters, url, "Updated");
            }, "Update");
          } else {
            that.createFilterSet(name, filters, url, "Created");
          }
          return that.trackMixpanel("data filter set added", {
            name: name,
            filters: filters
          });
        });
      });
      return this.updateUserFilterButtons();
    },
    createFilterSet: function(name, filters, url, action) {
      var that;
      that = this;
      return $.post(url, {
        name: name,
        filters: JSON.stringify(filters)
      }).done(function() {
        var filterLink;
        showAlert("success", action + " data filter set: " + name, true);
        that.removeFilterSet(name);
        that.$user_filters.find("ul").append("<li class='user-filter'><a>" + name + "</a></li>");
        if (that.$user_filters.find("li").length) {
          filterLink = document.querySelector('.filter-all-button');
          filterLink.setAttribute("href", filterLink.dataset.link);
          filterLink.removeAttribute("disabled");
        }
        that.setDataFilterSetTitle(name);
        return that.initFilters(filters);
      }).error(function(data) {
        var message;
        if (data.status === 400) {
          data = JSON.parse(data.responseText);
          message = data.message;
        } else {
          message = "Network error; please try again later!";
        }
        return showAlert("danger", message);
      });
    },
    setDefaultFilters: function(need_redirect) {
      if (need_redirect == null) {
        need_redirect = false;
      }
      this.setDataFilterSetTitle("Default");
      this.initFilters(this.$current_data_filters.data("default-filters") || [], need_redirect);
      return this.updateUserFilterButtons();
    },
    initRangeFilterAddButtons: function() {
      var that;
      that = this;
      return this.$filters.find("button[data-action=add]").click(function() {
        var $current_filter, $filter, filter_label, max, min, name, value, value_label;
        $filter = $(this).closest(".filter");
        name = $filter.data("filter");
        filter_label = $filter.find(".label").text();
        min = $filter.find(".min").val();
        max = $filter.find(".max").val();
        if (min !== "" && max !== "") {
          if (name === "date") {
            if (min > max) {
              showAlert("danger", "You can't set a date range that has no days in it (the 'Max' date on the right must the same as, or after, the 'Min' date on the left)", true);
              return;
            }
          } else {
            if (parseInt(min) > parseInt(max)) {
              showAlert("danger", "You can't set a filter range that has no values in it (the 'Max' value on the right must be equal to, or greater than, the 'Min' value on the left)", true);
              return;
            }
          }
          value_label = min + " - " + max;
        } else if (min !== "") {
          value_label = ">= " + min;
        } else if (max !== "") {
          value_label = "<= " + max;
        } else {
          return;
        }
        value = min + "|" + max;
        $current_filter = that.findFilter(name);
        if ($current_filter.length > 0) {
          $current_filter.find(".value").remove();
          that.addFilterValue($current_filter, value, value_label);
        } else {
          that.addFilter(filter_label, name, value, value_label, $filter);
        }
        if ($filter.closest(".filter").data("filter-type") === "data") {
          that.setDataFilterSetTitle();
        }
        return that.load();
      });
    },
    initUpdates: function() {
      var that;
      that = this;
      this.initUserFilters();
      this.initGroupBy();
      this.initRangeFilterAddButtons();
      this.$filter_items.filter("[data-search-url]").each(function(i, search) {
        return that.initSearch($(search));
      });
      this.$filters.find(".dropdown a").click(function(event) {
        var $button, $dropdown, label, name, value;
        event.preventDefault();
        $button = $(event.target);
        $dropdown = $button.closest(".dropdown");
        name = $dropdown.data("filter");
        value = $button.data("value");
        label = $button.text();
        that.addOrExtendFilter($dropdown.data("label"), name, value, label, $button);
        that.setDataFilterSetTitle();
        return that.load();
      });
      this.$current_filters.on("click", "button[data-action=remove]", function(event) {
        var $button, $label, $labels;
        $button = $(event.target);
        $label = $button.closest(".value");
        $labels = $label.closest(".values");
        $label.remove();
        if ($labels.find(".value").length === 1) {
          $labels.find(".or").remove();
          $labels.siblings(".btn-remove-filter-group").addClass("hidden");
        } else if ($labels.find(".value").length === 0) {
          $labels.closest(".filter").parent().remove();
        }
        if ($("#current-data-filters").children().length === 0) {
          $("#data-filters-none").show();
        }
        if ($("#current-table-filters").children().length === 0) {
          $("#table-filters-none").show();
        }
        if (this.dataset.name) {
          $(this).parent().parent().remove();
        }
        that.setDataFilterSetTitle();
        that.load();
        return baseStats.hideChart();
      });
      return this.$current_data_filters.on("click", ".btn-remove-filter-group", function(event) {
        $(event.target).closest("li").remove();
        if ($("#current-data-filters").children().length === 0) {
          $("#data-filters-none").show();
        }
        that.setDataFilterSetTitle();
        return that.load();
      });
    },
    addFilter: function(filter_label, name, value, label, $filter) {
      var $filter_badge, filter_type;
      baseStats.hideChart();
      $filter_badge = $(window.HAML["stats/client/templates/filter_badge"]({
        label: filter_label,
        name: name
      }));
      initTooltips($filter_badge);
      this.addFilterValue($filter_badge, value, label);
      filter_type = $filter.closest(".filter").data("filter-type");
      if (filter_type === "data") {
        $("#data-filters-none").hide();
        this.$current_data_filters.append($filter_badge);
      } else {
        $("#table-filters-none").hide();
        this.$current_table_filters.append($filter_badge);
      }
      return this.trackMixpanel("filter added", {
        value: value,
        label: label
      });
    },
    addFilterValue: function($filter_badge, value, label) {
      var $label, $labels, $values, is_initial;
      baseStats.hideChart();
      this.page = 1;
      $labels = $filter_badge.find(".values");
      $values = $labels.find(".value");
      is_initial = $values.length === 0;
      if ($values.length + 1 > 1) {
        $filter_badge.find(".btn-remove-filter-group").removeClass("hidden");
      }
      $label = $(window.HAML["stats/client/templates/filter_value"]({
        is_initial: is_initial,
        value: value,
        label: label
      }));
      initTooltips($label);
      return $labels.append($label);
    },
    findFilter: function(name) {
      var $filters;
      $filters = this.$current_filters.find(".filter[data-name=" + name + "]");
      return $filters;
    },
    initSearch: function($search) {
      var adapter, filter_label, name, source, that;
      that = this;
      name = $search.data("filter-name");
      filter_label = $search.data("filter-label");
      source = new Bloodhound({
        name: "stats-" + name,
        datumTokenizer: function(datum) {
          return Bloodhound.tokenizers.whitespace(datum.name);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: ($search.data("search-url")) + "?q=%QUERY",
          wildcard: "%QUERY",
          transform: function(items) {
            return items.items;
          }
        }
      });
      source.initialize();
      adapter = source.ttAdapter();
      return $search.typeahead({
        minLength: 2,
        items: 10,
        autoSelect: true,
        source: function(query, process) {
          return adapter(query, function() {
            return null;
          }, process);
        },
        sorter: function(items) {
          return items;
        },
        updater: function(item) {
          var $current_filter, already_in_filter, label, value;
          value = item.id;
          label = item.name;
          $current_filter = that.findFilter(name);
          if ($current_filter.length > 0) {
            already_in_filter = $current_filter.find("[data-value=" + value + "]").length > 0;
            if (already_in_filter) {
              return;
            }
            that.addFilterValue($current_filter, value, label);
          } else {
            that.addFilter(filter_label, name, value, label, $search, false);
          }
          that.setDataFilterSetTitle();
          that.load();
          return "";
        }
      });
    },
    initDatePickers: function() {
      return this.$date_pickers.datepicker({
        format: "yyyy-mm-dd",
        viewMode: "days",
        maxViewMode: "days",
        minViewMode: "days",
        clearBtn: true,
        autoclose: true
      });
    },
    get_url_for_load_data: function(is_filterset, field) {

      /*
      Get root for load url. It will be different for filterset list and usual list.
       */
      var path, url;
      if (is_filterset) {
        path = window.location.pathname.split("/").slice(1, 4).join("/");
      } else {
        path = window.location.pathname.split("/").slice(1, 3).join("/");
      }
      url = "/" + path + "/" + field + "/";
      return url;
    },
    load_url: function(need_redirect) {
      var field, redirect_url, searchResult, that, url;
      if (need_redirect == null) {
        need_redirect = false;
      }
      if (window.location.search) {
        that = this;
        searchResult = window.location.search.slice(1).replace(/%20/g, ' ');
        this.$user_filters.find('a').each(function(i, search) {
          var $selection, name;
          if ($(this).text() === searchResult) {
            $selection = $(this);
            name = $selection.text().trim();
            that.setDataFilterSetTitle(name);
            that.selectedField = $selection.text().trim();
            if (name !== "Default") {
              return $.get(that.$user_filters.find(".dropdown-toggle").data("url").replace("NAME", encodeURIComponent(name))).done(function(data) {
                that.initFilters(data.filters, true);
                return that.trackMixpanel("data filter set selected", {
                  name: name,
                  filters: data.filters
                });
              });
            }
          }
        });
      }
      if (this.$table.data("href")) {
        field = this.$table.data("field");
        url = "" + (this.$table.data("href")) + field + "/";
      } else {
        field = this.$group_by.data("value");
        url = this.get_url_for_load_data(this.is_filterset, field);
        if (window.location.pathname.indexOf('filter-set') >= 0 && need_redirect) {
          redirect_url = this.get_url_for_load_data(false, field);
          window.location.href = redirect_url + ("?" + this.selectedField);
          return;
        } else {
          window.history.pushState({}, "", url);
        }
      }
      this.$field_title.text($("#stats-group-by .label").text());
      this.$chart_filter_set_label.hide();
      return url + "data/";
    },
    filtersetsList: function() {
      var dropdownList, filtersets, selectList;
      this.filterList = $('.current-data-filtersets-list');
      filtersets = [];
      if (this.filterList.length) {
        this.filterList.each(function(index, search) {
          return filtersets.push(search.innerText);
        });
        if (this.filterList.length === 1) {
          selectList = document.getElementById('stats-user-filters');
          dropdownList = selectList.querySelectorAll('.user-filter');
          dropdownList.forEach(function(search, index) {
            if (search.innerText === filtersets.toString()) {
              return window.location.href = '/stats/prostats/all/' + ("?" + search.innerText);
            }
          });
        }
      }
      return filtersets;
    },
    load_data: function() {
      var filters, params;
      filters = this.exportFilters(this.$current_data_filters).concat(this.exportFilters(this.$current_table_filters));
      params = {
        column: this.column,
        dir: this.dir,
        page: this.page,
        filters: JSON.stringify(filters),
        filtersets: JSON.stringify(this.filtersetsList())
      };
      return params;
    },
    override_method: function() {
      return "POST";
    },
    update: function(data) {
      var $body, d, download_button, l, len, len1, need_show_isp, o, ref, ref1, txt;
      $body = $(window.HAML["stats/client/templates/stats_row"](data));
      this.$table.find("tbody").html($body);
      initTooltips($body);
      initPopovers($body);
      this.updateIcons();
      this.paginate(data.num_pages);
      this.can_convert_rows_to_filters = data.can_convert_rows_to_filters;
      this.$stats_filter_today.prop("disabled", data.num_runs_today === 0).find(".count").text(data.num_runs_today);
      this.$stats_filter_tomorrow.prop("disabled", data.num_runs_tomorrow === 0).find(".count").text(data.num_runs_tomorrow);
      download_button = $('#download-button');
      if (download_button.length) {
        txt = 'Download selections';
        if (data.num_runs_today === 0 && data.num_runs_tomorrow === 0) {
          download_button.attr("disabled", "disabled");
        } else if (data.num_runs_today > 250 || data.num_runs_tomorrow > 250) {
          download_button.attr("disabled", "disabled");
        } else {
          download_button.removeAttr("disabled");
          txt = txt + ': ' + data.num_runs_download;
        }
        download_button.text(txt);
      }
      if (this.is_filterset) {
        need_show_isp = true;
        ref = data.rows;
        for (l = 0, len = ref.length; l < len; l++) {
          d = ref[l];
          if (!d['average_price_isp']) {
            need_show_isp = false;
            break;
          }
        }
        if (need_show_isp) {
          $("th.js_isp, td.js_isp").show();
        }
        ({
          "else": $("th.js_isp, td.js_isp").hide()
        });
      } else {
        ref1 = data.rows;
        for (o = 0, len1 = ref1.length; o < len1; o++) {
          d = ref1[o];
          if (d['average_price_isp'] || d['p_and_l_isp'] || d['roi_isp']) {
            $("th.js_isp, td.js_isp").show();
          }
          ({
            "else": $("th.js_isp, td.js_isp").hide()
          });
        }
      }
      return this.updateRowsToFilterButton();
    },
    updateRowsToFilterButton: function() {
      return this.$rows_to_filters_button.attr("disabled", (!this.can_convert_rows_to_filters) || (this.$pagination.is(":visible") && $('#stats-box').find("tr.selected").length === 0));
    },
    updateUserFilterButtons: function() {
      var ref;
      this.$user_filters.find("[data-action=add]").attr("disabled", this.$user_filters.find(".user-filter").length >= this.$user_filters.data("max-filters") || this.$current_data_filters.text() === "");
      return this.$user_filters.find("[data-action=delete]").attr("disabled", (ref = this.getDataFilterSetTitle()) === "Default" || ref === "\u00a0");
    },
    showUpgradeMessage: function(minimum_membership) {
      this.$table.find("tbody").html("<tr><td colspan=100><a href='#' id='stats-disabled'>Upgrade to " + minimum_membership + " membership to see these statistics!</a></td></tr>");
      return $('#stats-disabled').click(function() {
        return anonymous.showUpgradeDialog("view stats", minimum_membership);
      });
    },
    initRowsToFilters: function() {
      var that;
      that = this;
      return this.$rows_to_filters_button.click(function() {
        var $stats_table, $title_rows, group_by;
        $stats_table = $("#stats-box").find("table.statistics");
        group_by = that.$group_by.data("value");
        $title_rows = $stats_table.find("tr.selected");
        if ($title_rows.length === 0) {
          if (that.$pagination.is(":visible")) {
            return;
          }
          $title_rows = $stats_table.find("tr");
        }
        $title_rows.find("td:first-child").each(function(i, item) {
          var $filter, $item, $label, key;
          $item = $(item);
          key = $item.data("key");
          if (key) {
            $filter = that.$filters.find("[data-filter=" + group_by + "]");
            $label = $filter.parent().find(".label");
            return that.addOrExtendFilter($label.text(), group_by, key, $item.text(), $filter, false);
          }
        });
        return that.load();
      });
    },
    initFilterDay: function() {
      var that;
      that = this;
      this.$stats_filter_today.click(function() {
        return that.postFilterDay(this, "today");
      });
      return this.$stats_filter_tomorrow.click(function() {
        return that.postFilterDay(this, "tomorrow");
      });
    },
    postFilterDay: function(button, day, action) {
      var data_filters, filtersets, that;
      if (action == null) {
        action = "create";
      }
      that = this;
      filtersets = [];
      if (this.filterList.length) {
        this.filterList.each(function(index, search) {
          return filtersets.push(search.innerText);
        });
      }
      data_filters = this.exportFilters(this.$current_data_filters);
      return $.post($(button).data("url"), {
        filters: JSON.stringify(data_filters),
        action: action,
        filtersets: JSON.stringify(filtersets)
      }).done(function(data) {
        var message;
        if (data.action === "replace") {
          message = "Replaced selection with " + data.total_selections + " runners";
        } else if (data.action === "merge") {
          message = "Merged selection, adding " + data.num_added + " new runners for a total of " + data.total_selections + " runners";
        } else {
          message = "Created selection with " + data.total_selections + " runners";
        }
        showAlert("success", message + " - <a href='" + data.url + "' target='_blank'>View selection</a>", true);
        return that.trackMixpanel("applied filter set to " + day, {
          filters: data_filters
        });
      }).error(function(data) {
        var $dialog;
        if (data.status === 400) {
          data = JSON.parse(data.responseText);
          $dialog = showDialog(data.html);
          $dialog.find("[data-action=replace]").click(function() {
            that.postFilterDay(button, day, "replace");
            return $dialog.modal('hide');
          });
          return $dialog.find("[data-action=merge]").click(function() {
            that.postFilterDay(button, day, "merge");
            return $dialog.modal('hide');
          });
        } else {
          return showAlert("danger", "Network Error", false);
        }
      });
    },
    exportFilters: function(filters) {
      return $.map(filters.find("li"), function(filter) {
        var $filter;
        $filter = $(filter);
        return {
          name: $filter.find(".badge").data("name"),
          values: $.map($filter.find(".value"), function(value) {
            var $value;
            $value = $(value);
            return {
              value: $value.data("value"),
              label: $value.find(".name").text().trim()
            };
          })
        };
      });
    },
    initFilters: function(filters, need_redirect) {
      var $base_filter, filter, l, label, len, len1, o, ref, sub_filter;
      if (need_redirect == null) {
        need_redirect = false;
      }
      this.$current_data_filters.empty();
      $("#data-filters-none").show();
      this.$current_table_filters.empty();
      $("#table-filters-none").show();
      for (l = 0, len = filters.length; l < len; l++) {
        filter = filters[l];
        $base_filter = this.$filters.find("[data-filter=" + filter.name + "]");
        label = $base_filter.closest(".filter").find(".label").text();
        ref = filter.values;
        for (o = 0, len1 = ref.length; o < len1; o++) {
          sub_filter = ref[o];
          this.addOrExtendFilter(label, filter.name, sub_filter.value, sub_filter.label, $base_filter, $base_filter.closest(".filter").data("unique") === 1);
        }
      }
      return this.load(null, null, need_redirect);
    }
  };

  entryStats = {
    $table: $("#entry-stats-table"),
    init: function() {
      var minimum_membership;
      if (this.$table.length === 0) {
        return;
      }
      $.extend(this, baseStats);
      this.initTable();
      if (this.$table.parents(".tab-content").length === 0) {
        this.trackMixpanel("loaded", {
          type: "entry"
        });
      }
      minimum_membership = this.$table.data("minimum-membership");
      if (minimum_membership) {
        return this.showUpgradeMessage(minimum_membership);
      } else {
        if (!this.$table.data("href")) {
          return this.initUpdates();
        }
      }
    }
  };

  selectionStats = {
    $table: $("#selection-stats-table"),
    init: function() {
      var minimum_membership;
      if (this.$table.length === 0) {
        return;
      }
      $.extend(this, baseStats);
      this.initTable();
      if (this.$table.parents(".tab-content").length === 0) {
        this.trackMixpanel("loaded", {
          type: "selection"
        });
      }
      minimum_membership = this.$table.data("minimum-membership");
      if (minimum_membership) {
        return this.showUpgradeMessage(minimum_membership);
      } else {
        if (!this.$table.data("href")) {
          return this.initUpdates();
        }
      }
    }
  };

  allStats = {
    $table: $("#all-stats-table"),
    init: function() {
      var minimum_membership;
      if (this.$table.length === 0) {
        return;
      }
      $.extend(this, baseStats);
      this.initTable();
      if (this.$table.parents(".tab-content").length === 0) {
        this.trackMixpanel("loaded", {
          type: "allStats"
        });
      }
      minimum_membership = this.$table.data("minimum-membership");
      if (minimum_membership) {
        return this.showUpgradeMessage(minimum_membership);
      } else {
        if (!this.$table.data("href")) {
          return this.initUpdates();
        }
      }
    }
  };

  defaultEventHandlers = {
    init: function() {
      $("#stats-nav.btn-group, #stats-pagination.btn-group").on("click", function() {
        return baseStats.hideChart();
      });
      $("#stats-group-by .form-control").on("change", function() {
        return baseStats.hideChart();
      });
      if (baseStats.is_filterset) {
        baseStats.$current_filters.children().first().hide();
        return $('.group_by').attr("disabled", "disabled");
      } else {
        $('.group_by').removeAttr("disabled");
        return baseStats.$current_filters.children().first().show();
      }
    }
  };

  entryStats.init();

  selectionStats.init();

  allStats.init();

  defaultEventHandlers.init();

  dashboard = {
    $leaderboard_tabs: $("#dashboard-leaderboard-nav").find("li"),
    $stats_tabs: $('#dashboard-stats').find('a[data-toggle="tab"]'),
    init: function() {
      this.initLeaderboard();
      return this.initStats();
    },
    initLeaderboard: function() {
      var default_button;
      if (this.$leaderboard_tabs.length === 0) {
        return;
      }
      default_button = this.$leaderboard_tabs.filter('.active');
      leaderboard.load(default_button.find("a").data("href"), {
        dashboard: true
      });
      return this.$leaderboard_tabs.find("a").click(function(event) {
        var $tab;
        $tab = $(event.target);
        return leaderboard.load($tab.data('href'), {
          dashboard: true
        });
      });
    },
    initStats: function() {
      if (this.$stats_tabs.length === 0) {
        return;
      }
      entryStats.load();
      return this.$stats_tabs.click(function(event) {
        var $body, $target, href;
        $target = $(event.target);
        $body = $($target.attr("href")).find("tbody");
        if ($body.html()) {
          return;
        } else {
          baseStats.hideChart();
        }
        href = $target.attr("href");
        if (href === "#stats-entry") {
          return entryStats.load();
        } else if (href === "#stats-selection") {
          return selectionStats.load();
        } else if (href === "#stats-all") {
          return allStats.load();
        }
      });
    }
  };

  dashboard.init();

  last_nap_update_requested_at = (new Date()).getTime();

  saveNapPicks = function(data) {
    last_nap_update_requested_at = (new Date()).getTime();
    data["requested_at"] = last_nap_update_requested_at;
    return $.ajax({
      method: "PUT",
      url: "/entries/entry/" + date_slug + "/",
      data: data
    }).done(function(response) {
      var $button, $counter, count;
      if (response.requested_at < last_nap_update_requested_at) {
        return;
      }
      $race_tables_container.find(".runner").each(function(i, run) {
        var $run, id;
        $run = $(run);
        id = parseInt($run.data("run-id"));
        switch (id) {
          case response.nap:
            return $run.val("nap");
          case response.nb:
            return $run.val("nb");
          case response.reserve:
            return $run.val("reserve");
          default:
            return $run.val("");
        }
      });
      count = 0;
      if (response.nap != null) {
        count++;
      }
      if (response.nb != null) {
        count++;
      }
      if (response.reserve != null) {
        count++;
      }
      $counter = $("#nap-count");
      $counter.text(count);
      $button = $counter.parent();
      if (count === 3) {
        $button.addClass("highlight");
        if (is_mobile) {
          return $button.trigger("click");
        }
      } else {
        return $button.removeClass("highlight");
      }
    });
  };

  $.previous_nap_value = "";

  napPicksChange = function() {
    var $run, $select, course_data, course_name, course_time, data, horse_name, run_id, value, value_;
    $select = $(this);
    value = $select.val();
    data = {};
    $run = $select.closest("tr");
    run_id = $run.data("run-id");
    horse_name = $run.find(".name a").eq(0).text();
    course_data = $select.closest("table").find("thead .name div a");
    course_time = course_data.eq(0).text();
    course_name = course_data.eq(1).text();
    if ($.previous_nap_value !== "") {
      data[$.previous_nap_value] = "";
    }
    if (value !== "") {
      data[value] = run_id;
      $race_tables_container.find("select").each(function(i, other_select) {
        var $other_select;
        $other_select = $(other_select);
        if (!$other_select.is($select) && $other_select.val() === value) {
          $other_select.val("");
          return false;
        }
      });
    }
    if (value) {
      value_ = value.toUpperCase();
      $.rtrApp.trackMixpanel(value_ + " choice made", {
        run_id: run_id,
        horse_name: horse_name,
        course_data: course_data,
        course_name: course_name,
        course_time: course_time
      });
    } else {
      $.rtrApp.trackMixpanel("NAP/NB/RES choice cleared");
    }
    $race_tables_container.find("option[value!='']").each(function(i, option) {
      var $option, label, option_run_id, option_value;
      $option = $(option);
      option_run_id = $option.closest("tr").data("run-id");
      label = {
        nap: "NAP",
        nb: "NB",
        reserve: "Res"
      }[$option.val()];
      option_value = $option.val();
      if ((option_value === value && option_run_id === run_id) || (option_value === $.previous_nap_value)) {
        return $option.html(label);
      } else if (option_value === value) {
        return $option.html(label + " (currently " + horse_name + " in " + course_time + " @ " + course_name + ")");
      }
    });
    $.previous_nap_value = value;
    return saveNapPicks(data);
  };

  enterNapDialog = function(dialog_markup, $button) {
    var $dialog;
    $dialog = showDialog(dialog_markup);
    $(".bfsp-enabled-checkbox").each(function(i, item) {
      var $_bfsp, $_odds, $item, $last_cell, $row, toggleData;
      $item = $(item);
      $row = $item.closest("tr");
      $last_cell = $row.find("td:eq(5)");
      $_odds = $last_cell.find(".hideable-odds");
      $_bfsp = $last_cell.find(".hideable-bfsp");
      toggleData = function(checked) {
        $_odds.toggle(!checked);
        return $_bfsp.toggle(checked);
      };
      toggleData($item.prop("checked"));
      return $item.change(function() {
        return toggleData(this.checked);
      });
    });
    $dialog.find(".clear").click(function() {
      return show_confirm_dialog("Are you sure you want to clear NAPs?", function() {
        var item, l, len, params, ref;
        $("#nap-count").text("0");
        $button.removeClass("highlight");
        ref = $(".runner select");
        for (l = 0, len = ref.length; l < len; l++) {
          item = ref[l];
          $(item).val("");
        }
        showAlert("success", "NAP competition cleared", true);
        last_nap_update_requested_at = (new Date()).getTime();
        params = {
          nap: "",
          nb: "",
          reserve: "",
          requested_at: last_nap_update_requested_at
        };
        return $.ajax({
          method: "PUT",
          url: "/entries/entry/" + date_slug + "/",
          data: params
        }).done(function() {
          $race_tables_container.find("select > option").each(function(i, option) {
            var $option, first_word_match;
            $option = $(option);
            first_word_match = $option.text().match(/\w+/);
            if (first_word_match != null) {
              return $option.text(first_word_match[0]);
            }
          });
          return $.rtrApp.trackMixpanel("NAP competition cleared");
        });
      }, "Yes", "No");
    });
    $dialog.find(".authorize").click(function() {
      var $twitter_tab;
      $.rtrApp.trackMixpanel("NAP competition authorized");
      $twitter_tab = window.open($(this).data("twitter-auth-url"), "popupWindow", "width=800,height=600");
      return $twitter_tab.focus();
    });
    $dialog.find(".confirm").off("click").on("click", function() {
      $("#loading-indicator").show();
      return $.post("/entries/entry/" + date_slug + "/", {
        comment: $dialog.find(".comment").val(),
        bfsp_nap: $dialog.find("#bfsp-nap").prop("checked"),
        bfsp_nb: $dialog.find("#bfsp-nb").prop("checked"),
        bfsp_reserve: $dialog.find("#bfsp-reserve").prop("checked")
      }).done(function(data) {
        if (data.message) {
          $.rtrApp.trackMixpanel("NAP competition posted");
          showAlert("success", data.message, false);
          $race_tables_container.find(".runner").each(function(i, item) {
            var $run, html, run_id;
            $run = $(item);
            run_id = parseInt($run.data("run-id"));
            html = (function() {
              switch (run_id) {
                case data.nap:
                  return "NAP";
                case data.nb:
                  return "NB";
                case data.reserve:
                  return "Res";
                default:
                  return "";
              }
            })();
            return $run.find("td.nap").html("<div>" + html + "</div>");
          });
          $("#enter-nap").remove();
          return $("#show-nap").show();
        } else {
          return enterNapDialog(data, $button);
        }
      }).fail(function(data) {
        if (data.status === 400) {
          data = data.responseJSON;
          return showAlert("danger", data.message, false);
        }
      }).always(function() {
        return $("#loading-indicator").hide();
      });
    });
    return true;
  };

  $("#enter-nap").click(function() {
    var $button;
    if (anonymous.isAnonymous()) {
      anonymous.showUpgradeDialog("enter the NAP competition", "Free");
      return;
    }
    $button = $(this);
    if ($button.data("opentips")) {
      $button.data("opentips")[0].hide();
    }
    $('#loading-indicator').show();
    return $.get($button.data("href")).done(function(data) {
      enterNapDialog(data, $button);
      return $.rtrApp.trackMixpanel("NAP dialog opened");
    }).always(function() {
      return $('#loading-indicator').hide();
    });
  });

  $("#show-nap").click(function() {
    var $button;
    $button = $(this);
    if ($button.data("opentips")) {
      $button.data("opentips")[0].hide();
    }
    $('#loading-indicator').show();
    return $.get($button.data("href")).done(function(data) {
      return showDialog(data);
    }).always(function() {
      return $('#loading-indicator').hide();
    });
  });

  if ($('#choose-example-days').length > 0) {
    date_vals = $('#choose-example-days-text').val().split(',');
    example_calendar = $('#choose-example-days').multiDatesPicker({
      maxDate: 0,
      altField: '#choose-example-days-text',
      addDates: (function() {
        var l, len, results;
        results = [];
        for (l = 0, len = date_vals.length; l < len; l++) {
          val = date_vals[l];
          results.push(new Date(val));
        }
        return results;
      })()
    });
    example_calendar.datepicker('setDate', null);
    $('#save-example-days').click(function() {
      var $button;
      $button = $(this);
      return $.post($button.data('update-url'), {
        example_days: $('#choose-example-days-text').val()
      }).done(function(data) {
        $('#current-example-days').html(data.example_days);
        return showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
      });
    });
  }

  if ($('#choose-free-days-text').length > 0) {
    date_vals = $('#choose-free-days-text').val().split(',');
    free_calendar = $('#choose-free-days').multiDatesPicker({
      minDate: 0,
      altField: '#choose-free-days-text',
      addDates: (function() {
        var l, len, results;
        results = [];
        for (l = 0, len = date_vals.length; l < len; l++) {
          val = date_vals[l];
          results.push(new Date(val));
        }
        return results;
      })()
    });
    free_calendar.datepicker('setDate', null);
    $('#save-free-days').click(function() {
      var $button;
      $button = $(this);
      return $.post($button.data('update-url'), {
        free_days: $('#choose-free-days-text').val()
      }).done(function(data) {
        $('#current-free-days').html(data.free_days);
        return showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
      });
    });
  }

  $("#hints-disabled").change(function() {
    var button;
    button = $(this);
    return $.ajax({
      method: "PUT",
      url: "/members/",
      data: {
        "hints-disabled": button.prop("checked")
      }
    }).done(function() {
      if (button.prop("checked")) {
        return $("#hint").parent('.alert').remove();
      } else {
        return resetHints();
      }
    });
  });

  resetHints = function() {
    return $.ajax({
      method: "PUT",
      url: $("#reset-hints-button").data("href")
    }).done(function(data) {
      var hint;
      hint = $("#hint");
      if (hint.length > 0) {
        hint.replaceWith(data);
      } else {
        showAlert("info", data, false);
      }
      return addEventsToHint();
    });
  };

  addEventsToHint = function() {
    var $hint;
    $hint = $("#hint");
    if ($hint.length === 0) {
      return;
    }
    $hint.find('[data-action=close]').click(function() {
      return $hint.parent().remove();
    });
    return $hint.find('[data-action=navigation]').click(function() {
      return $.get($(this).data("href")).done(function(data) {
        $hint.replaceWith(data);
        return addEventsToHint();
      });
    });
  };

  $("#reset-hints-button").click(resetHints);

  addEventsToHint();

  edit_nag_me_template = null;

  $nag_me_settings = $("#nag-me-settings");

  show_nag_me_dialog = function(mode, horse_id, run_id, nag_me_id, horse_name, horse_nationality, auto_delete, note) {
    var $dialog, $remove_nag_me_but, context, html, sendNagMeData, title;
    if (horse_id == null) {
      horse_id = null;
    }
    if (run_id == null) {
      run_id = null;
    }
    if (nag_me_id == null) {
      nag_me_id = null;
    }
    if (horse_name == null) {
      horse_name = null;
    }
    if (horse_nationality == null) {
      horse_nationality = null;
    }
    if (auto_delete == null) {
      auto_delete = "";
    }
    if (note == null) {
      note = "";
    }
    if (anonymous.isAnonymous()) {
      anonymous.showUpgradeDialog("create a NagMe", "Free");
      return;
    }
    if (horse_name) {
      title = (mode === 'create' ? 'Create' : 'Edit') + " NagMe for " + horse_name;
      if (horse_nationality) {
        title += " (" + horse_nationality + ")";
      }
    } else {
      title = "Find Horse to add NagMe for";
    }
    context = {
      id: nag_me_id,
      horse_id: horse_id,
      run_id: run_id,
      horse_name: horse_name,
      horse_nationality: horse_nationality,
      auto_delete: auto_delete,
      note: note,
      mode: mode,
      title: title,
      auto_delete_choices: $nag_me_settings.data("auto-delete-choices"),
      note_max_length: $nag_me_settings.data("note-max-length")
    };
    html = window.HAML["profiles/client/templates/nag_me_dialog"](context);
    $dialog = showDialog(html);
    $.rtrApp.trackMixpanel("NagMe dialog opened");
    if (mode === "search") {
      enableNagSearch($dialog);
    }
    $dialog.find("#nag-me-note").on('keyup keypress', nagMeNoteCounter);
    $remove_nag_me_but = $dialog.find('.remove-nag-me');
    $remove_nag_me_but.on('click', function() {
      nag_me_id = $('#nag-me-id').val();
      $dialog.modal('hide');
      return show_confirm_dialog("Are you sure you want to delete this NagMe?", function() {
        return sendNagMeData({}, "DELETE", nag_me_id);
      });
    });
    $dialog.find('.save-nag-me').click(function() {
      var $horse_name, data_to_send, error, method;
      data_to_send = {
        'auto-delete': $('#nag-me-auto-delete').val(),
        'run-id': $('#nag-me-run-id').val(),
        'horse-id': $('#nag-me-horse-id').val(),
        'id': $("#nag-me-id").val(),
        note: $('#nag-me-note').val()
      };
      $horse_name = $("#nag-me-horse-typeahead");
      if ($horse_name.length === 1) {
        if (/^\s*$/.test($horse_name.val())) {
          error = "Please pick a horse!";
        } else if ($horse_name.val() !== $horse_name.data("picked-name")) {
          error = "Name of horse is incomplete!<br/>Please pick a new one!";
        }
        if (error) {
          $horse_name.focus();
          setTimeout(function() {
            return $("#nag-me-error").html(error).fadeIn("fast").delay(3000).fadeOut("slow");
          }, 100);
          return;
        }
      }
      method = mode === "edit" ? "PUT" : "POST";
      return sendNagMeData(data_to_send, method, $('#nag-me-id').val());
    });
    return sendNagMeData = function(data_to_send, method, id) {
      var url;
      $dialog.modal('hide');
      url = $nag_me_settings.data("url");
      if (id) {
        url = "" + url + id + "/";
      }
      return $.ajax({
        method: method,
        dataType: 'json',
        url: url,
        data: data_to_send
      }).done(function(data) {
        var $button, $buttons, $nag_me_table, $row, row;
        showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
        if (method === "DELETE") {
          $button = $("span.nag-me[data-id=" + id + "]");
          $buttons = $("span.nag-me[data-horse-id=" + ($button.data("horse-id")) + "]");
          $buttons.removeClass('active');
          update_nag_me_count(-1);
          return $.rtrApp.trackMixpanel("NagMe deleted", data_to_send);
        } else {
          if (method === "POST") {
            $nag_me_table = $("#nag-mes");
            if ($nag_me_table.length === 1) {
              row = window.HAML["profiles/client/templates/_nag_me_row"]($.extend(data["nag_me"], {
                auto_delete_choices: $nag_me_settings.data("auto-delete-choices"),
                note_max_length: $nag_me_settings.data('note-max-length')
              }));
              $row = $(row);
              $("#nag-mes").prepend($row);
              initTooltips($row);
            }
          }
          $("span.nag-me[data-horse-id=" + data['nag_me']['horse']['id'] + "]").attr("data-id", data["nag_me"]["id"]).data("note", data["nag_me"]["note"]).data("auto-delete", data["nag_me"]["auto_delete"]).addClass('active');
          update_nag_me_count(+1);
          return $.rtrApp.trackMixpanel("NagMe posted", data_to_send);
        }
      }).error(function(data) {
        data = JSON.parse(data.responseText);
        return showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
      });
    };
  };

  nagMeNoteCounter = function() {
    var $text_area, max_length, note, num_control, text_remaining;
    $text_area = $(this);
    note = $text_area.val();
    max_length = $nag_me_settings.data('note-max-length');
    text_remaining = max_length - note.length;
    num_control = $text_area.closest('td, form').find('.symbol-count');
    if (text_remaining <= 0) {
      $text_area.val(note.substring(0, max_length));
    }
    num_control.text(text_remaining);
    return $text_area.closest("tr").find(".save").prop("disabled", false);
  };

  $('#nag-mes').on('click', '.save', function() {
    var $button, $row, data;
    $button = $(this);
    $row = $button.closest('tr');
    data = {
      'note': $row.find(".note").val(),
      'auto-delete': $row.find(".auto-delete").val()
    };
    return $.ajax({
      method: "PUT",
      url: "" + ($nag_me_settings.data("url")) + ($row.data('nag-me-id')) + "/",
      data: data
    }).done(function(data) {
      showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
      $button.data('note', data.note);
      return $button.data('auto-delete', data.auto_delete);
    }).error(function(data) {
      data = JSON.parse(data.responseText);
      return showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
    });
  }).on('keyup keypress', '.note', nagMeNoteCounter).on('change', '.auto-delete', function() {
    return $(this).closest("tr").find(".save").prop("disabled", false);
  }).on('click', '.delete', function() {
    var $row;
    $row = $(this).closest("tr");
    return show_confirm_dialog("Are you sure you want to delete this NagMe?", function() {
      return $.ajax({
        method: "DELETE",
        url: "" + ($nag_me_settings.data("url")) + ($row.data("nag-me-id")) + "/"
      }).done(function(data) {
        showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
        $row.remove();
        return update_nag_me_count(-1);
      }).error(function(data) {
        data = JSON.parse(data.responseText);
        return showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
      });
    });
  });

  update_nag_me_count = function(modification) {
    return $('#number-of-nags').text(parseInt($('#number-of-nags').text()) + modification);
  };

  enableNagSearch = function($dialog) {
    var $search, adapter, source;
    $search = $('#nag-me-horse-typeahead');
    source = new Bloodhound({
      name: 'horse-name',
      datumTokenizer: function(datum) {
        return Bloodhound.tokenizers.whitespace(datum.name);
      },
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: $nag_me_settings.data("typeahead-horse-url") + "?q=%QUERY",
        wildcard: '%QUERY',
        transform: function(items) {
          return items.items;
        }
      }
    });
    source.initialize();
    adapter = source.ttAdapter();
    $search.typeahead({
      minLength: 2,
      items: 10,
      autoSelect: true,
      source: function(query, process) {
        return adapter(query, function() {
          return null;
        }, process);
      },
      matcher: function() {
        return true;
      },
      sorter: function(items) {
        return items;
      },
      afterSelect: function(item) {
        $search.data("picked-name", item.name + " (" + item.nationality + ")");
        $('#nag-me-horse-id').val(item.id);
        return $dialog.find('.save-nag-me').prop("disabled", false);
      },
      displayText: function(item) {
        return item.name + " (" + item.nationality + ")";
      }
    });
    return $search.focus();
  };

  $('#add-nag-me').click(function(e) {
    e.stopPropagation();
    return show_nag_me_dialog("search");
  });

  renderNagMes = function() {
    var $element, data, json, l, len, nag_me, ref, results, row;
    $element = $('#nag-mes-json');
    json = $element.text();
    if (!json) {
      return;
    }
    $element.remove();
    data = JSON.parse(json);
    ref = data["nag_mes"];
    results = [];
    for (l = 0, len = ref.length; l < len; l++) {
      nag_me = ref[l];
      row = $(window.HAML["profiles/client/templates/_nag_me_row"]($.extend(nag_me, data)));
      $("#nag-me-rows").append(row);
      results.push(initTooltips(row));
    }
    return results;
  };

  renderNagMes();

  $("button[data-action=unlink-twitter]").click(function(e) {
    var $button, twitterScreenName, url, username;
    $button = $(e.target);
    twitterScreenName = $button.data("twitter-screen-name");
    username = $button.data("username");
    url = $button.data("url");
    return show_confirm_dialog("Do you really want to unlink the twitter account, <a href='https://twitter.com/" + twitterScreenName + "'>@" + twitterScreenName + "</a>, from this RTR account?<br/>This cannot be undone, but you will be able to link a new Twitter account!", function() {
      return $.ajax({
        method: "GET",
        url: url
      }).done(function() {
        $("#twitter-" + username).text("Not set.");
        return showAlert("success", "Unlinked Twitter account: @" + twitterScreenName, true);
      }).fail(function() {
        return showAlert("danger", "Failed to unlink twitter!", false);
      });
    });
  });

  $("button#profile-subscription-update").click(function(e) {
    var button, data, spinner;
    button = $(this);
    button.addClass("disabled").attr("disabled", "disabled");
    spinner = $("#profile-subscription-update-spinner");
    spinner.show();
    data = {};
    $("#subscriptions input").each(function() {
      data[$(this).attr("name")] = $(this).is(":checked");
    });
    return $.ajax({
      method: "PUT",
      url: "/members/subscription",
      data: data
    }).done(function() {
      return showAlert("success", "Subscription settings were successfully saved", true, true);
    }).fail(function() {
      return showAlert("danger", "Failed to save subscription settings", false);
    }).always(function() {
      spinner.hide();
      return button.removeClass("disabled").removeAttr("disabled");
    });
  });

  $("#disable-notifications").change(function() {
    return $.ajax({
      method: "PUT",
      url: "/members/",
      data: {
        'disable-notifications': $(this).prop("checked")
      }
    });
  });

  $("#show-non-runners").change(function() {
    return $.ajax({
      method: "PUT",
      url: "/members/",
      data: {
        'show-non-runners': $(this).prop("checked")
      }
    }).always(function() {
      return $("tr.non-runner").each(function(i, non_runner) {
        return $(non_runner).toggleClass("hidden");
      });
    });
  });

  $("#show-fractional-odds").change(function() {
    var value;
    value = $(this).prop("checked");
    return $.ajax({
      method: "PUT",
      url: "/members/",
      data: {
        'show-fractional-odds': value
      }
    }).always(function() {
      if (value) {
        $(".isp-fractional").removeClass("hidden");
        return $(".isp-decimal").addClass("hidden");
      } else {
        $(".isp-fractional").addClass("hidden");
        return $(".isp-decimal").removeClass("hidden");
      }
    });
  });

  $("#show-nationalities").change(function() {
    var value;
    value = $(this).prop("checked");
    return $.ajax({
      method: "PUT",
      url: "/members/",
      data: {
        "show-nationalities": value
      }
    }).always(function() {
      if (value) {
        return $(".bred").removeClass("hidden");
      } else {
        return $(".bred").addClass("hidden");
      }
    });
  });

  $("#freeze-horse-name").change(function() {
    var value;
    value = $(this).prop("checked");
    return $.ajax({
      method: "PUT",
      url: "/members/",
      data: {
        "freeze-horse-name": value
      }
    }).always(function() {
      if (value) {
        $(".js_horse_name").addClass("frozen");
        if ($("div#race-tables").css("overflow-x") === "auto") {
          updateFrozenElementMobile();
        } else {
          updateFrozenElement();
        }
      } else {
        $(".frozen").css("position", "relative").css("left", "auto").css("border-right", "").css("background", "");
        $(".frozen span.bred, .frozen div.badge").show();
        $(".js_horse_name").removeClass("frozen");
      }
      return resizeHorseNameColumn();
    });
  });

  $("#stats-mode a").click(function() {
    var $option;
    $option = $(this);
    $("#stats-mode button").text($option.data("label"));
    history.pushState({}, null, "?" + ($.param({
      stats: $option.data("name")
    })));
    raceRenderer.options.stats_mode = $option.data("name");
    return raceRenderer.renderRaces();
  });

  stats_mode = getQueryDict().stats;

  if (stats_mode === "place_sr") {
    $("#stats-mode > button").text("PS");
  } else if (stats_mode === "win_pr") {
    $("#stats-mode > button").text("WP");
  }

  $race_tables_container = $("#race-tables");

  race_date_str = $race_tables_container.data("race-date-str");

  raceUpdater = {
    replaceCells: function(old_cells, new_cells) {
      var num_callbacks;
      new_cells = $(new_cells).map(function() {
        return this.get();
      });
      initTooltips(new_cells);
      old_cells = $(old_cells).map(function() {
        return this.get();
      });
      new_cells.find("select").on("focus", function() {
        return $.previous_nap_value = this.value;
      }).change(napPicksChange);
      new_cells.hide();
      num_callbacks = old_cells.length;
      return old_cells.fadeOut(600, function() {
        var i, l, new_cell, old_cell, ref;
        if (--num_callbacks > 0) {
          return;
        }
        for (i = l = 0, ref = old_cells.length; 0 <= ref ? l < ref : l > ref; i = 0 <= ref ? ++l : --l) {
          new_cell = $(new_cells[i]);
          old_cell = $(old_cells[i]);
          old_cell.replaceWith(new_cell);
        }
        return new_cells.fadeIn(1200);
      });
    },
    performRaceUpdate: function(old_body, new_body) {
      var i, j, l, nap_select, naps_changed, new_cells, new_run, new_run_cell, new_run_cells, new_runs, o, old_cells, old_run, old_run_cell, old_run_cells, ref, ref1, runs_stopping_running, table_body, that;
      that = this;
      old_cells = [];
      new_cells = [];
      new_runs = new_body.find("tr");
      console.assert(new_runs.length > 0, "Expected to find at least one runner in the new table.");
      runs_stopping_running = [];
      naps_changed = {};
      for (i = l = 0, ref = new_runs.length; 0 <= ref ? l < ref : l > ref; i = 0 <= ref ? ++l : --l) {
        new_run = $(new_runs[i]);
        old_run = old_body.find("tr[data-run-id=" + (new_run.data("run-id")) + "]");
        console.assert(old_run.length === 1, "Old runner not found: " + (new_run.data("run-id")));
        if (old_run.hasClass("runner") && new_run.hasClass("non-runner")) {
          table_body = old_run.parent();
          table_body.append(old_run);
          old_run.removeClass("runner");
          old_run.addClass("non-runner");
          old_run.find("div").removeAttr("style");
          nap_select = old_run.find("select");
          if (!nap_select.prop("disabled")) {
            runs_stopping_running.push(old_run);
            if (old_run.find("select").val() !== "") {
              naps_changed[old_run.find("select").val()] = "";
            }
            nap_select.prop("disabled", true).val("");
          }
          if ($("#show-non-runners").prop("checked")) {
            old_run.css("display", "table-row");
          }
        }
        old_run_cells = old_run.find("td > .updates");
        new_run_cells = new_run.find("td > .updates");
        for (j = o = 0, ref1 = new_run_cells.length; 0 <= ref1 ? o < ref1 : o > ref1; j = 0 <= ref1 ? ++o : --o) {
          old_run_cell = $(old_run_cells[j]);
          new_run_cell = $(new_run_cells[j]);
          if (old_run_cell.html() !== new_run_cell.html()) {
            old_cells.push(old_run_cell);
            new_cells.push(new_run_cell);
          }
        }
      }
      if (runs_stopping_running.length > 0) {
        saveNapPicks(naps_changed);
        $(runs_stopping_running).each(function(i, item) {
          return showAlert("info", "Non-runner: " + (that.runInfo($(item))), false);
        });
      }
      return this.replaceCells(old_cells, new_cells);
    },
    raceInfo: function(header) {
      return "in the " + (header.data("time")) + " @ " + (header.data("course"));
    },
    runInfo: function(run) {
      return "RTR " + (run.find("td.rtr_rank div").text()) + ", " + (run.find("td.name").eq(0).text()) + " in the " + (run.data("time")) + " @ " + (run.data("course"));
    },
    runInfoShort: function(run) {
      return (run.find("td.name").eq(0).text()) + " in the " + (run.data("time")) + " @ " + (run.data("course"));
    },
    updateRaceTable: function(new_table) {
      var new_going, new_header, new_runs, old_going, old_header, old_runs, old_table, race_id, that;
      that = this;
      console.assert(new_table.length === 1, "Expected new table to be an object");
      race_id = new_table.data("race-id");
      old_table = $race_tables_container.find("table.race-table[data-race-id=" + race_id + "]");
      console.assert(old_table.length === 1, "Expected old table to be found");
      old_header = $(old_table.find("tr.card-header"));
      console.assert(old_header.length === 1, "Expected to find a card-header in the old table");
      new_header = $(new_table.find("tr.card-header"));
      console.assert(new_header.length === 1, "Expected to find a card-header in the new table");
      if (old_header.html() !== new_header.html()) {
        old_header.replaceWith(new_header);
        initTooltips(new_header);
        old_going = old_header.find("td.js_going").eq(0).text();
        new_going = new_header.find("td.js_going").eq(0).text();
      }
      old_runs = old_table.find("> tbody");
      new_runs = new_table.find("> tbody");
      return this.performRaceUpdate(old_runs, new_runs);
    },
    init: function() {
      var that;
      if (!$race_tables_container.hasClass("live-update")) {
        return;
      }
      console.log("Managing live updates of selections/naps");
      that = this;
      return this.timer = setInterval(function() {
        return that.detect_out_of_date_selections_and_entries();
      }, 1000);
    },
    detect_out_of_date_selections_and_entries: function() {
      var nap_runs_out_of_time, now_uk, selection_runs_out_of_time;
      if (!windowIsShown()) {
        return;
      }
      now_uk = moment().tz("Europe/London");
      if (now_uk.format("dddd MMMM D, YYYY") !== race_date_str) {
        return;
      }
      nap_runs_out_of_time = [];
      selection_runs_out_of_time = [];
      $race_tables_container.find("tr.runner").each(function(i, item) {
        var $nap_select, $run, race_time;
        $run = $(item);
        race_time = $run.data("time");
        $nap_select = $run.find("select");
        if (now_uk.format("HH:mm") < race_time) {
          return false;
        }
        if ($nap_select.val()) {
          nap_runs_out_of_time.push($run);
        }
        $nap_select.prop("disabled", true).val("");
        if ($run.hasClass("active")) {
          $run.removeClass("active");
          return selection_runs_out_of_time.push($run);
        }
      });
      if (nap_runs_out_of_time.length > 0) {
        this.update_naps(nap_runs_out_of_time);
      }
      if (selection_runs_out_of_time.length > 0) {
        return this.update_selections(selection_runs_out_of_time);
      }
    },
    update_naps: function(nap_runs_out_of_time) {
      var $counter, count, that;
      $counter = $("#nap-count");
      count = parseInt($counter.text()) - nap_runs_out_of_time.length;
      $counter.text(count);
      that = this;
      $(nap_runs_out_of_time).each(function(i, item) {
        return showAlert("warning", "NAP entry removed when race started: " + (that.runInfo($(item))), false);
      });
      return $("#enter-nap").removeClass("highlight");
    },
    update_selections: function(selection_runs_out_of_time) {
      var $counter, count, that;
      $counter = $("#selection-count");
      count = parseInt($counter.text()) - selection_runs_out_of_time.length;
      $counter.text(count);
      that = this;
      return $(selection_runs_out_of_time).each(function(i, item) {
        return showAlert("warning", "Selection removed when race started: " + (that.runInfo($(item))), false);
      });
    }
  };

  raceUpdater.init();

  $.detect_out_of_date_selections_and_entries = function() {
    return raceUpdater.detect_out_of_date_selections_and_entries();
  };

  stompMonitor = {
    updateRace: function(race_index) {
      var $table;
      $table = raceRenderer.renderHTML(race_index);
      return raceUpdater.updateRaceTable($table);
    },
    updateRaces: function(url) {
      var that;
      that = this;
      console.log("Updating race(s) at " + (moment().format()));
      return $.get(url).done(function(data) {
        var i, timer;
        raceRenderer.races = data["races"];
        raceRenderer.update_diff = data["update"];
        raceRenderer.renderUpdate();
        that.updateRace(0);
        if (raceRenderer.races.length > 1) {
          clearInterval(timer);
          i = 1;
          return timer = setInterval(function() {
            that.updateRace(i);
            i += 1;
            if (i >= raceRenderer.races.length) {
              clearInterval(timer);
              return console.log("Updated " + raceRenderer.races.length + " races");
            }
          }, 100);
        } else {
          return console.log("Updated single race");
        }
      }).fail(function() {
        return console.error("Update request failed");
      });
    },
    subscribeToUpdates: function(topic) {
      var that;
      that = this;
      return this.stomp.subscribe("/topic/" + topic, function(message) {
        var data;
        data = JSON.parse(message.body);
        if (windowIsHidden()) {
          return that.add_pending_update(data.url);
        } else {
          return that.updateRaces(data.url);
        }
      });
    },
    subscribeToAlerts: function(topic) {
      return this.stomp.subscribe("/topic/" + topic, function(message) {
        var data;
        data = JSON.parse(message.body);
        return showAlert(data["type"], data["message"], data["fades_out"]);
      });
    },
    subscribeToTomorrowAvailable: function(topic) {
      return this.stomp.subscribe("/topic/" + topic, function(message) {
        var alert, data, tomorrow_button;
        data = JSON.parse(message.body);
        tomorrow_button = $("#tomorrow-button");
        if (tomorrow_button.prop("disabled")) {
          tomorrow_button.prop("disabled", false).attr("href", data.url);
        }
        alert = "<a href=\"" + data.url + "\" class=\"alert-link\">Races for tomorrow</a> are now available!";
        return showAlert("info", alert, false);
      });
    },
    init: function() {
      var on_connected, on_error, that, ws;
      ws = new SockJS(window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/stomp");
      this.stomp = Stomp.over(ws);
      this.stomp.heartbeat.outgoing = 0;
      this.stomp.heartbeat.incoming = 0;
      that = this;
      on_connected = function() {
        var topics;
        topics = $race_tables_container.data("topics");
        that.subscribeToUpdates(topics["update"]);
        that.subscribeToAlerts(topics["alerts"]);
        return that.subscribeToTomorrowAvailable(topics["tomorrow_available"]);
      };
      on_error = function(error) {
        if (error.headers) {
          return console.error(error.headers.message);
        } else {
          return console.error("STOMP Error");
        }
      };
      return this.stomp.connect("rtr", $race_tables_container.data("stomp-password"), on_connected, on_error);
    },
    add_pending_update: function(url) {
      var that, update_pending;
      if (this.update_pending_timer) {
        return;
      }
      console.log("Delaying update (hidden)");
      that = this;
      update_pending = function() {
        if (windowIsShown()) {
          clearInterval(that.update_pending_timer);
          that.update_pending_timer = null;
          console.log("Performing delayed update (visible again)");
          return that.updateRaces(url);
        }
      };
      return this.update_pending_timer = setInterval(update_pending, 200);
    },
    cleanup: function() {
      this.stomp.disconnect();
      return this.stomp.reset();
    }
  };

  if ($race_tables_container.length > 0) {
    stompMonitor.init();
    $.rtrApp.sm = stompMonitor;
  }

  raceRenderer = {
    races: null,
    columns: null,
    options: null,
    entry: null,
    update_diff: null,
    update_value: {},
    update_text: {},
    $tables: $("#race-tables"),
    $update: $("#race-update"),
    renderHTML: function(race_number) {
      var $table, race;
      race = $.extend(this.races[race_number], {
        columns: this.columns,
        options: this.options,
        entry: this.entry
      });
      race.race = race;
      $table = $(window.HAML["races/client/templates/table"](race));
      return $table;
    },
    renderRace: function(race_number) {
      var $table;
      $table = this.renderHTML(race_number);
      $table.hide().appendTo(this.$tables);
      $table.find("select").focus(function() {
        return $.previous_nap_value = this.value;
      }).change(napPicksChange);
      initTooltips($table);
      if (is_mobile) {
        $table.find("a.unlink-on-mobile").click(function(e) {
          return e.preventDefault();
        });
      }
      $table.css("visibility", "hidden").show();
      resizeHorseNameColumn();
      return $table.hide().css("visibility", "visible").fadeIn("fast");
    },
    renderRaces: function() {
      var race_number, that;
      if (!this.races || this.races.length === 0) {
        this.$tables.html("<p>No races.</p>");
        this.$update.hide();
        return;
      }
      if (this.options.is_show_mobile_preset_dialog) {
        showMobilePresetDialog();
      }
      if (this.races_timer !== null) {
        clearInterval(this.races_timer);
        this.races_timer = null;
      }
      this.$tables.html("");
      this.renderRace(0);
      race_number = 1;
      that = this;
      if (this.races.length > 1) {
        return that.races_timer = setInterval(function() {
          that.renderRace(race_number);
          race_number += 1;
          if (race_number === that.races.length) {
            clearInterval(that.races_timer);
            that.races_timer = null;
            $(".black.glyphicon-time").removeAttr("style");
            return console.log("Rendered " + that.races.length + " races");
          }
        }, 50);
      }
    },
    renderUpdate: function() {
      var k, l, len, m, m_existing, name, ref, ref1, table, update, v;
      if (!this.update_diff || !this.races || this.races.length === 0 || is_mobile) {
        return;
      }
      ref = this.update_diff;
      for (k in ref) {
        v = ref[k];
        m = moment.tz(v, "Europe/London");
        if (!this.update_value[k]) {
          this.update_value[k] = v;
          this.update_text[k] = "Last updated " + m.fromNow();
        } else {
          m_existing = moment.tz(this.update_value[k], "Europe/London");
          if (m > m_existing) {
            this.update_value[k] = v;
            this.update_text[k] = "Last updated " + m.fromNow();
          }
        }
      }
      ref1 = this.columns.names;
      for (l = 0, len = ref1.length; l < len; l++) {
        name = ref1[l];
        v = this.update_diff['_default'];
        if (this.update_value[name] === void 0) {
          m = moment.tz(v, "Europe/London");
          this.update_value[name] = v;
          this.update_text[name] = "Last updated " + m.fromNow();
        }
      }
      update = {
        columns: this.columns,
        options: this.options,
        update_text: this.update_text
      };
      table = $(window.HAML["races/client/templates/update_table"](update));
      this.$update.html(table);
      $(window).scroll();
      initTooltips($("table.race-update"));
      setTimeout(this.renderUpdate.bind(this), 15000);
      return setTimeout(this.renderUpdateGlyph.bind(this), 15000);
    },
    renderUpdateGlyph: function() {
      return $(".black.glyphicon-time").removeAttr("style");
    },
    init: function() {
      var that;
      if (this.$tables.length === 0) {
        return;
      }
      that = this;
      this.options = extractJsonFromHTML("#options-data");
      this.options.stats_mode = getQueryDict().stats || "win_sr";
      this.columns = extractJsonFromHTML("#columns-data");
      this.addEnabledColumns(this.columns);
      this.entry = extractJsonFromHTML("#entry-data");
      return $.get("data/").done(function(data) {
        that.races = data.races;
        that.update_diff = data.update;
        console.log("Retrieved race data");
        console.log(data);
        if (data['races'] === 'These Early Ratings are only available for Professional Members') {
          return that.$tables.html(data['races']);
        } else {
          that.renderRaces();
          return that.renderUpdate();
        }
      }).fail(function() {
        that.$tables.html("<p>Failed to retrieve race data - please <a href='#'>reload</a> the page.</p>");
        return console.log("Failed to get race data back");
      });
    },
    addEnabledColumns: function(columns) {
      var enabled_columns;
      enabled_columns = {};
      $.each(columns.names, function(i, column) {
        return enabled_columns[column] = true;
      });
      return columns.enabled = enabled_columns;
    }
  };

  raceRenderer.init();

  showMobilePresetDialog = function() {
    var $dialog, html, options;
    options = {
      "hide_cancel": true
    };
    html = window.HAML["profiles/client/templates/mobile_preset_dialog"](options);
    $dialog = showDialog(html);
    return $dialog.find("button.preset").click(function() {
      var mobile_preset_type;
      mobile_preset_type = $(this).data("preset");
      return $.ajax({
        method: "PUT",
        url: "/members/",
        data: {
          "mobile-preset-type": mobile_preset_type
        }
      }).done(function(data) {
        if (data.columns.names !== raceRenderer.columns.names) {
          raceRenderer.columns = data.columns;
          raceRenderer.addEnabledColumns(raceRenderer.columns);
          raceRenderer.options.is_show_mobile_preset_dialog = false;
          return raceRenderer.renderRaces();
        }
      });
    });
  };

  $("#race-columns-button").click(function() {
    $('#loading-indicator').show();
    if ((raceRenderer.options && raceRenderer.options.is_mobile_client) || (historyRenderer.options && historyRenderer.options.is_mobile_client)) {
      showMobilePresetDialog();
      return $('#loading-indicator').hide();
    } else {
      return $.get($(this).data("href")).done(function(data) {
        var DEFAULT_URL, dialog;
        DEFAULT_URL = "/members/";
        dialog = showDialog(data);
        dialog.find("button.clear").click(function() {
          return dialog.find("input").each(function(i, item) {
            var input;
            input = $(item);
            if (!input.prop("disabled")) {
              return input.prop("checked", false);
            }
          });
        });
        dialog.find("button.all").click(function() {
          return dialog.find("input").each(function(i, item) {
            var input;
            input = $(item);
            if (!input.prop("disabled")) {
              return input.prop("checked", true);
            }
          });
        });
        dialog.find("button.preset").click(function() {
          var preset_name, preset_type, presets;
          presets = {};
          presets.BASIC_PRESET_COLUMNS = ["nap", "cloth_number", "stall_draw", "horse_name", "result", "rtr_score", "rtr_rank", "value_odds", "win_price", "value_percentage", "place_price", "form", "av10_rank", "av3_rank"];
          presets.PROFESSIONAL_PRESET_COLUMNS = ["nap", "cloth_number", "stall_draw", "horse_name", "nag_me", "result", "rtr_score", "rtr_rank", "value_odds", "win_price", "value_percentage", "place_price", "form", "r5", "r4", "r3", "r2", "r1", "av10_rank", "av3_rank", "class", "days", "horse_c_stats", "horse_d_stats", "horse_cd_stats", "horse_g_stats", "trainer_name", "trainer_d28_stats", "trainer_a_stats", "trainer_c_stats", "trainer_t_stats", "jockey_name", "jockey_a_stats", "jockey_c_stats", "jockey_t_stats", "sire_a_stats", "sire_c_stats", "sire_t_stats", "sire_dt_stats", "sire_g_stats", "jockey_and_trainer_a_stats"];
          preset_type = $(this).html().toUpperCase();
          preset_name = preset_type + "_PRESET_COLUMNS";
          return dialog.find("input").each(function(i, item) {
            var input, ref;
            input = $(item);
            if (presets.hasOwnProperty(preset_name)) {
              return input.prop("checked", (ref = input.prop("name"), indexOf.call(presets[preset_name], ref) >= 0));
            } else {
              return input.prop("checked", true);
            }
          });
        });
        return dialog.find("button.update").click(function() {
          var hidden_race_columns;
          hidden_race_columns = [""];
          dialog.find("input").each(function(i, item) {
            var input;
            input = $(item);
            if (!input.is(":checked")) {
              return hidden_race_columns.push(input.attr("name"));
            }
          });
          data = {
            "hidden-race-columns": hidden_race_columns
          };
          if (historyRenderer.races) {
            data["history-type"] = historyRenderer.options.list_type;
          }
          return $.ajax({
            method: "PUT",
            url: DEFAULT_URL,
            data: data
          }).done(function(data) {
            if (raceRenderer.columns) {
              raceRenderer.columns = data.columns;
              raceRenderer.addEnabledColumns(raceRenderer.columns);
              return raceRenderer.renderRaces();
            } else {
              historyRenderer.columns = data.columns;
              raceRenderer.addEnabledColumns(historyRenderer.columns);
              return historyRenderer.render();
            }
          });
        });
      }).always(function() {
        return $('#loading-indicator').hide();
      });
    }
  });

  initFrozenColumn = function() {
    this.frozenColumnData.EXTRA_SPACE_FROZEN = 30;
    this.frozenColumnData.EXTRA_SPACE_DEFAULT = 80;
    this.frozenColumnData.frozen_element_position = $("td.js_horse_name").first().offset();
    return this.frozenColumnData.frozen_is_touch_device = indexOf.call(document.documentElement, 'ontouchstart') >= 0 || navigator.userAgent.search(/Touch|Android|iPad|iPhone|iPod|iWatch/i) !== -1;
  };

  getHorseNameColumnWidth = function() {
    var $horse_names, extra, l, len, max_horse_name_width, ref, result, span;
    max_horse_name_width = 0;
    $horse_names = $("#race-tables table td.js_horse_name");
    ref = $horse_names.find("span:first-child");
    for (l = 0, len = ref.length; l < len; l++) {
      span = ref[l];
      max_horse_name_width = Math.max(max_horse_name_width, $(span).innerWidth());
    }
    if ($horse_names.first().css("position") === "absolute") {
      extra = this.frozenColumnData.EXTRA_SPACE_FROZEN;
    } else {
      extra = this.frozenColumnData.EXTRA_SPACE_DEFAULT;
    }
    result = (max_horse_name_width + extra) + "px";
    return result;
  };

  resizeHorseNameColumn = function() {
    return $("col.horse_name, .frozen").css("width", getHorseNameColumnWidth());
  };

  updateFrozenElement = function() {
    var element, frozen_element_position, sl;
    frozen_element_position = $("td.js_horse_name").first().offset();
    element = $(window);
    sl = element.scrollLeft();
    if (this.frozenColumnData.frozen_element_position && sl > this.frozenColumnData.frozen_element_position.left) {
      $("th.frozen").each(function() {
        var bg;
        $(this).css("margin-top", "-1px");
        bg = $(this).css("background");
        return $(this).parent().css("background", bg);
      });
      $("td.frozen").each(function() {
        return updateFrozenElementBackground($(this));
      });
      $(".frozen").css({
        "border-right": "5px solid rgb(221, 221, 221)",
        "left": sl,
        "position": "absolute",
        "width": getHorseNameColumnWidth(),
        "z-index": "10"
      });
      return $(".frozen span.bred, .frozen div.badge").hide();
    } else {
      $(".frozen").css({
        "border-right": "",
        "left": "auto",
        "position": "",
        "z-index": "auto"
      });
      return $(".frozen span.bred, .frozen div.badge").show();
    }
  };

  updateFrozenElementMobile = function() {
    var element, eo, sl;
    element = $("div#race-tables");
    eo = element.offset();
    sl = element.scrollLeft();
    if (this.frozenColumnData.frozen_element_position && eo && (sl + eo.left > this.frozenColumnData.frozen_element_position.left)) {
      $("th.frozen").each(function() {
        var bg;
        $(this).css("margin-top", "-1px");
        bg = $(this).css("background");
        return $(this).parent().css("background", bg);
      });
      $("td.frozen").each(function() {
        return updateFrozenElementBackground($(this));
      });
      $(".frozen").css({
        "border-right": "5px solid rgb(221, 221, 221)",
        "left": 0 + eo.left,
        "position": "absolute",
        "width": getHorseNameColumnWidth(),
        "z-index": "10"
      });
      return $(".frozen span.bred, .frozen div.badge").hide();
    } else {
      $(".frozen").css({
        "border-right": "",
        "left": "auto",
        "position": "",
        "z-index": "auto"
      });
      return $(".frozen span.bred, .frozen div.badge").show();
    }
  };

  updateFrozenElementBackgroundIn = function(el) {
    return el.css("background", "");
  };

  updateFrozenElementBackgroundOut = function(el) {
    return el.css("background", "url(/static/images/gradbacklblue.png) #8db4e3");
  };

  updateFrozenElementBackground = function(el) {
    var tr;
    tr = el.parent();
    if (tr.hasClass("active") || (tr.hasClass("hover") && !this.frozenColumnData.frozen_is_touch_device)) {
      return updateFrozenElementBackgroundIn(el);
    } else {
      return updateFrozenElementBackgroundOut(el);
    }
  };

  $(window).scroll(function() {
    if (this.frozenColumnData && !this.frozenColumnData.frozen_element_position) {
      initFrozenColumn();
    }
    if ($("div#race-tables").css("overflow-x") !== "auto") {
      updateFrozenElement();
      return resizeHorseNameColumn();
    }
  });

  $("div#race-tables").scroll(function() {
    if (this.frozenColumnData && !this.frozenColumnData.frozen_element_position) {
      initFrozenColumn();
    }
    updateFrozenElementMobile();
    return resizeHorseNameColumn();
  });

  $race_tables_container.on("click", "span.nag-me", function(event) {
    var $button, auto_delete, horse_id, horse_name, horse_nationality, mode, nag_me_id, note, run_id;
    $button = $(this);
    event.stopPropagation();
    note = $button.data('note');
    horse_name = $button.data('horse-name');
    horse_nationality = $button.data('horse-nationality');
    nag_me_id = $button.data("id");
    run_id = $button.closest("tr").data('run-id');
    horse_id = $button.data('horse-id');
    auto_delete = $button.data('auto-delete');
    mode = $button.hasClass('active') ? "edit" : "create";
    return show_nag_me_dialog(mode, horse_id, run_id, nag_me_id, horse_name, horse_nationality, auto_delete, note);
  });

  $race_navigation = $('.date-navigation.race-dates input');

  example_days = $race_navigation.data('example-days');

  example_days = example_days === void 0 || example_days === false ? [] : example_days.split(',');

  current_race_date = null;

  $race_navigation.datepicker({
    format: "DD MM d, yyyy",
    todayBtn: "linked",
    orientation: "top",
    viewMode: "days",
    maxViewMode: "days",
    minViewMode: "days",
    autoclose: true,
    beforeShowDay: (function(_this) {
      return function(date) {
        var date_str;
        if (example_days.length === 0) {
          return true;
        }
        date.setHours(12);
        date_str = date.toISOString().slice(0, 10);
        if ($.inArray(date_str, example_days) !== -1) {
          return {
            classes: 'highlight'
          };
        } else {
          return false;
        }
      };
    })(this)
  }).on("changeDate", function(ev) {
    var date;
    date = ev.date;
    date.setHours(12);
    if (current_race_date !== null && current_race_date.getTime() === date.getTime()) {
      return;
    } else {
      current_race_date = date;
    }
    date = date.toISOString().slice(0, 10);
    if ($race_navigation.data('example-days')) {
      return window.location.href = "/examples/races/" + date + "/";
    } else {
      return window.location.href = "/races/" + date + "/";
    }
  });

  current_race_date = $race_navigation.datepicker("getDate");

  if ($.isFunction(current_race_date.setHours)) {
    current_race_date.setHours(12);
  }

  $("#run-selection-show").click(function() {
    var $button, clearSelection;
    if (anonymous.isAnonymous()) {
      anonymous.showUpgradeDialog("post your selections", "Free");
      return;
    }
    $button = $(this);
    if ($button.attr("data-opentips")) {
      $button.data("opentips")[0].hide();
    }
    $('#loading-indicator').show();
    clearSelection = function() {
      $("#selection-count").text("0");
      $button.prop("disabled", false);
      $(".runner").removeClass("active");
      return $.rtrApp.trackMixpanel("Selections cleared");
    };
    return $.get($button.data("href")).done(function(data) {
      var $dialog;
      $dialog = showDialog(data);
      $dialog.find(".clear").click(function() {
        return show_confirm_dialog("Are you sure you want to clear this selection?", function() {
          $dialog.modal("hide");
          return $.ajax({
            method: "DELETE",
            url: "/selections/list/" + date_slug + "/"
          }).done(function() {
            return clearSelection();
          }).fail(function() {
            return showAlert("danger", "Failed to clear selections - try again later!", false);
          });
        }, "Yes", 'No');
      });
      $dialog.find(".post").click(function() {
        var comment;
        comment = $dialog.find(".comment").val();
        return $.post("/selections/post_to_forum/" + date_slug + "/", {
          comment: comment
        }).done(function(data) {
          showAlert("success", data.message);
          return $.rtrApp.trackMixpanel("Selections posted");
        }).fail(function(response) {
          data = response.responseJSON;
          if (data && data.message) {
            return showAlert("warning", data.message, false);
          } else {
            return showAlert("danger", "Failed to post selection - try again later!", false);
          }
        });
      });
      $dialog.find(".download").click(function() {
        var comment;
        comment = $dialog.find(".comment").val();
        data = {
          comment: comment
        };
        window.location.href = "/selections/download/" + date_slug + "/?" + ($.param(data));
        showAlert("success", "Selections downloaded", true);
        return $.rtrApp.trackMixpanel("Selections downloaded");
      });
      return $dialog.find(".download-fake").click(function() {
        return showAlert("warning", "Only Premium members can download their selections!", true);
      });
    }).always(function() {
      return $('#loading-indicator').hide();
    });
  });

  last_selection_requested_at = (new Date()).getTime();

  $race_tables_container.on("click", "td.hover", function(event) {
    var $runner, new_now_date, now_date, now_time, now_uk;
    $runner = $(this).closest("tr");
    if ($(event.target).is("a")) {
      return;
    }
    now_uk = moment().tz("Europe/London");
    now_date = now_uk.format("YYYY-MM-DD");
    now_time = now_uk.format("HH:mm");
    if (now_date > date_slug || (now_date === date_slug && now_time > $runner.data("time"))) {
      return;
    }
    new_now_date = moment(moment().tz("Europe/London").add(2, 'd').format('YYYY-MM-DD'));
    if (date_slug > new_now_date) {
      return;
    }
    return $.updateSelection($(this));
  });

  $.updateSelection = function(item) {
    var $counter, $runner, _updateSelectionCounter, count, method;
    _updateSelectionCounter = function(count) {
      return $counter.text(count);
    };
    $runner = $(item).closest("tr");
    $runner.toggleClass("active");
    updateFrozenElementBackground($runner.find("td.frozen").first());
    $counter = $("#selection-count");
    count = parseInt($counter.text());
    if ($runner.hasClass("active")) {
      count += 1;
      method = "POST";
    } else {
      count -= 1;
      method = "DELETE";
    }
    _updateSelectionCounter(count);
    return $.ajax({
      method: method,
      url: "/selections/" + ($runner.data("run-id")) + "/",
      data: {
        requested_at: +(new Date()).getTime()
      }
    }).done(function(data) {
      var params, verb;
      verb = method === "POST" ? "added" : "deleted";
      params = {
        course: $runner.data("course"),
        date: date_slug,
        race_time: $runner.data("time"),
        run_id: $runner.data("run-id")
      };
      $.rtrApp.trackMixpanel("Selection " + verb, params);
      if (data.requested_at < last_selection_requested_at) {
        return;
      }
      _updateSelectionCounter(data.selected.length);
      return $("#race-tables").find(".runner").each(function(_, $runner) {
        $runner = $($runner);
        if (data.selected.indexOf(parseInt($runner.data("run-id"))) === -1) {
          return $runner.removeClass("active");
        } else {
          return $runner.addClass("active");
        }
      });
    }).fail(function() {
      return showAlert("danger", "Failed to set selection - please reload page", true);
    });
  };

  initPagination = function() {
    var $pagination, base_url, html;
    $pagination = $("#static-pagination");
    if ($pagination.length === 0) {
      return;
    }
    base_url = $pagination.data("base-url");
    $pagination.on("click", "[data-page]", function(e) {
      var page;
      page = $(e.target).data("page");
      if (!page) {
        page = $(e.target).parent().data("page");
      }
      return location.href = "" + base_url + page + "/";
    });
    html = window.HAML["rating_the_races/client/templates/pagination"]({
      page: $pagination.data("page"),
      num_pages: $pagination.data("num-pages")
    });
    $pagination.html(html);
    return initTooltips($pagination);
  };

  initPagination();

  initRaceUpdateRow = function() {
    return $(window).on("scroll", function() {});
  };

  date_slug = $race_tables_container.data("date-slug");

  this.frozenColumnData = {};

  scroll_to_race_anchor = function(race_id) {
    var anchor_id, goto_race_anchor, timer;
    anchor_id = "#race-" + race_id;
    goto_race_anchor = function() {
      var offset_height;
      window.location.href = anchor_id;
      offset_height = $("#header").outerHeight() + $("#navigation-bar").outerHeight() + $("#toolbar").outerHeight();
      return $('html').animate({
        scrollTop: $("html").scrollTop() - offset_height
      }, 1);
    };
    if ($(anchor_id).length > 0) {
      return goto_race_anchor();
    } else {
      return timer = setInterval(function() {
        if ($(anchor_id).length > 0) {
          goto_race_anchor();
          return clearInterval(timer);
        }
      }, 50);
    }
  };

  $("#races-list-anchors").find(".dropdown-menu").find("a").on('click', function(event) {
    var $anchor, href;
    event.preventDefault();
    $anchor = $(this);
    href = $anchor.attr("href");
    if (href) {
      return window.location.href = href;
    } else {
      return scroll_to_race_anchor($anchor.attr("item-id"));
    }
  });

  $("#races-key-button").click(function() {
    $('#loading-indicator').show();
    return $.get($(this).data("href")).done(function(data) {
      return showDialog(data);
    }).always(function() {
      return $('#loading-indicator').hide();
    });
  });

  $("#races-per-page-button").click(function() {
    $('#loading-indicator').show();
    return $.get($(this).data("href")).done(function(data) {
      var dialog;
      dialog = showDialog(data);
      return dialog.find("button.update").click(function() {
        var count;
        count = parseInt(dialog.find("input").val());
        if (!isNaN(count) && (1 < count && count < 10)) {
          if (count > 5 && !$("#warning").is(":visible")) {
            $("#warning").show();
            return false;
          } else {
            return $.ajax({
              method: "PUT",
              url: "/members/",
              data: {
                "races-count": count
              }
            }).done(function(data) {
              return location.reload();
            });
          }
        } else {
          $("#error").show();
          return false;
        }
      });
    }).always(function() {
      return $('#loading-indicator').hide();
    });
  });

  initTouchStyles();

  initFrozenColumn();

  initRaceUpdateRow();

  $(function() {
    var hash;
    hash = window.location.hash;
    if (hash.match(/^#race-\d+$/)) {
      scroll_to_race_anchor(hash.substr(6));
    }
    if (location.search === "?selection=show") {
      return $("#run-selection-show").trigger("click");
    }
  });

  $('.tabs-with-panes a').click(function(event) {
    var container, tab_button;
    event.preventDefault();
    tab_button = $(this);
    container = tab_button.parent().parent().parent();
    container.find('li').removeClass("active");
    tab_button.parent("li").addClass("active");
    container.find('.tab-pane').removeClass("active");
    return $(tab_button.attr('href')).addClass("active");
  });

  addChosen = function(elems, type) {
    if (type == null) {
      type = 'default';
    }
    if (!$.isFunction(elems.chosen)) {
      return;
    }
    if (type === "with-numbers") {
      return elems.chosen({
        no_results_text: ' '
      }).on('chosen:showing_dropdown', function(evt, obj) {
        var select;
        select = $(this);
        select.data('option-clicked', false);
        if (select.data('attach-click') !== false) {
          obj.chosen.search_results.on('mousedown', function() {
            return select.data('option-clicked', true);
          });
          select.data('attach-click', false);
        }
        if (select.data('new-value')) {
          val = select.data('new-value');
          select.data('new-value', null);
          select.find("option[value='" + val + "']").remove();
          select.trigger('chosen:updated');
          return obj.chosen.search_field.val(val);
        } else {
          return obj.chosen.search_field.val('');
        }
      }).on('chosen:hiding_dropdown', function(evt, obj) {
        var select, value;
        select = $(this);
        if (select.data('option-clicked')) {
          select.data('new-value', null);
          return obj.chosen.search_field.val('');
        } else {
          value = parseFloat(obj.chosen.search_field.val());
          if (value) {
            select.data('new-value', value);
            select.append("<option value='" + value + "'>" + value + "</option>");
            select.val(value);
            return select.trigger('chosen:updated');
          }
        }
      });
    } else if (type === 'without-search') {
      return elems.chosen({
        disable_search: true
      });
    } else {
      return elems.chosen();
    }
  };

  addStrategyEvents = function(node) {
    initTooltips(node);
    addChosen(node.find("select[data-type='lhs']"));
    addChosen(node.find("select[data-type='op']"), 'without-search');
    return node.find("select[data-type='rhs']").each(function() {
      var elem;
      elem = $(this);
      return addChosen(elem, elem.attr('field-type') === 'list' ? 'without-search' : 'with-numbers');
    });
  };

  createBoolSelect = function(val, dismissable) {
    var bool_select, container, inner_li, li, parent_container, remove, ul;
    if (val == null) {
      val = "and";
    }
    if (dismissable == null) {
      dismissable = true;
    }
    parent_container = $('#substrategy-container').clone();
    container = parent_container.children('div').first();
    ul = parent_container.children('ul').first();
    li = $('<li></li>', {
      "class": 'border'
    });
    bool_select = container.find('select').first();
    bool_select.change(function() {
      var is_and;
      is_and = bool_select.val() === 'and';
      li.toggleClass('bool-and', is_and).toggleClass('bool-or', !is_and);
      return li.attr('data-bool', bool_select.val());
    }).val(val).change();
    if (dismissable) {
      remove = $("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>");
      remove.click(function() {
        return li.remove();
      });
      remove.prependTo(container);
    }
    inner_li = ul.find('li').first();
    ul.find('.add-node').click(function() {
      var elem;
      elem = createConditionSelect();
      elem.insertBefore(inner_li);
      return addStrategyEvents(elem);
    });
    ul.find('.add-node-set').click(function() {
      var elem;
      elem = createBoolSelect();
      elem.insertBefore(inner_li);
      return addStrategyEvents(elem);
    });
    li.append(container, ul);
    return li;
  };

  createConditionSelect = function(lhs_val, op_val, rhs_val) {
    var container, field_type, lhs, li, op, remove, rhs_bool, rhs_select, selected_option;
    if (lhs_val == null) {
      lhs_val = null;
    }
    if (op_val == null) {
      op_val = null;
    }
    if (rhs_val == null) {
      rhs_val = null;
    }
    li = $('<li></li>');
    container = $('#condition-container').clone().removeAttr('id').removeAttr('style');
    rhs_select = container.find('select[data-type="rhs"]').first();
    rhs_bool = container.find('input[data-type="rhs"]').first();
    lhs = container.find('select[data-type="lhs"]').first();
    op = container.find('select[data-type="op"]').first();
    lhs.change(function() {
      var camels, field_type, index, is_added, l, len, parts, ref, selected_option, vals;
      selected_option = $(this).find("option:selected");
      field_type = selected_option.attr('field-type');
      rhs_bool.remove();
      op.next().remove();
      op.remove();
      rhs_select.next().remove();
      rhs_select.remove();
      is_added = container.width() > 0;
      if (field_type === 'composite') {
        vals = selected_option.attr('field-vals');
        rhs_select.attr('field-type', vals ? 'list' : 'composite');
        if (!vals) {
          container.append(op.show());
          if (is_added) {
            addChosen(op, 'without-search');
          }
        }
        container.append(rhs_select.show());
        rhs_select.empty();
        if (vals) {
          parts = vals.split(';');
          camels = parts[1].split(',');
          ref = parts[0].split(',');
          for (index = l = 0, len = ref.length; l < len; index = ++l) {
            val = ref[index];
            rhs_select.append($("<option value='" + val + "'>" + camels[index] + "</option>"));
          }
          if (is_added) {
            return addChosen(rhs_select, 'without-search');
          }
        } else {
          rhs_select.html(lhs.html());
          if (is_added) {
            return addChosen(rhs_select, 'with-numbers');
          }
        }
      } else {
        return container.append(rhs_bool);
      }
    });
    field_type = 'composite';
    if (lhs_val !== null) {
      lhs.val(lhs_val);
    }
    lhs.change();
    selected_option = lhs.find("option:selected");
    field_type = selected_option.attr('field-type');
    if (op_val !== null) {
      op.val(op_val);
    }
    if (rhs_val !== null) {
      if (field_type === 'composite') {
        if (rhs_select.find("option[value='" + rhs_val + "']").length === 0) {
          rhs_select.append("<option value='" + rhs_val + "'>" + rhs_val + "</option>");
          rhs_select.data('new-value', rhs_val);
        }
        rhs_select.val(rhs_val);
      } else {
        rhs_bool.prop('checked', rhs_val);
      }
    }
    remove = $("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>");
    remove.click(function() {
      return li.remove();
    });
    remove.prependTo(container);
    li.append(container);
    return li;
  };

  buildTree = function(data, is_root) {
    var elem, l, len, li, node, ref;
    if (is_root == null) {
      is_root = false;
    }
    if ($.isEmptyObject(data)) {
      return createBoolSelect("and", !is_root);
    } else {
      if (data.type) {
        node = createBoolSelect(data.type, !is_root);
        li = node.find('li').first();
        ref = data.nodes;
        for (l = 0, len = ref.length; l < len; l++) {
          elem = ref[l];
          buildTree(elem).insertBefore(li);
        }
        return node;
      } else {
        return createConditionSelect(data.lhs, data.op, data.rhs);
      }
    }
  };

  strategy_tree = $('.strategy-tree').first();

  if (strategy_tree) {
    field = $("#" + (strategy_tree.attr('strategy-id')));
    strategy_tree.closest('form').submit(function(e) {
      var form;
      e.preventDefault();
      form = $(this);
      field.val(JSON.stringify(treeToJson(strategy_tree)));
      field = $("<input type='hidden' name='strategy'/>");
      $('#loading-indicator').show();
      return $.post(form.attr('action'), form.serialize()).done(function(data) {
        return showAlert(data.alert.type, data.alert.message, data.alert.fade_out);
      }).always(function() {
        return $('#loading-indicator').hide();
      });
    });
    data = JSON.parse(field.val() || '{}');
    strategy_tree.html('');
    tree = buildTree(data, true);
    strategy_tree.append(tree);
    addStrategyEvents(tree);
  }

  treeToJson = function(tree, is_root) {
    var arr, len_li_children, li_children;
    if (is_root == null) {
      is_root = true;
    }
    arr = [];
    tree = $(tree);
    li_children = tree.children('li');
    len_li_children = li_children.length;
    li_children.each(function(i, item) {
      var children, elem, len_children, operator, operator_val, result, rhs, rhs_val;
      item = $(item);
      children = item.children('ul');
      len_children = children.length;
      if (!(i === len_li_children - 1 && len_children === 0)) {
        if (len_children > 0) {
          result = treeToJson(children[0], false);
          if (result.length > 1) {
            return arr.push({
              type: item.attr('data-bool'),
              nodes: result
            });
          } else if (result.length === 1) {
            if (is_root) {
              return arr.push({
                type: item.attr('data-bool'),
                nodes: result
              });
            } else {
              return arr.push(result[0]);
            }
          }
        } else {
          operator = item.find("select[data-type='op']").first();
          rhs = item.find("[data-type='rhs']").first();
          operator_val = operator ? operator.val() : null;
          rhs_val = rhs.is('select') ? rhs.val() : rhs.prop('checked');
          elem = {
            lhs: item.find("select[data-type='lhs']").first().val(),
            op: operator_val,
            rhs: rhs_val
          };
          if (operator_val !== null) {
            elem.op = operator_val;
          }
          return arr.push(elem);
        }
      }
    });
    if (is_root) {
      if (arr.length === 1) {
        return arr[0];
      } else {
        return arr;
      }
    } else {
      return arr;
    }
  };

  historyRenderer = {
    runs: null,
    options: null,
    columns: null,
    $table: $("#horse-history"),
    init: function() {
      var that;
      if (this.$table.length === 0) {
        return;
      }
      this.options = extractJsonFromHTML("#options-data");
      this.options.stats_mode = getQueryDict().stats || "win_sr";
      this.columns = extractJsonFromHTML("#columns-data");
      that = this;
      return $.get("data/").done(function(data) {
        that.runs = data.runs;
        console.log("Retrieved history data");
        raceRenderer.addEnabledColumns(that.columns);
        return that.render();
      }).fail(function() {
        that.$table.html("<p>Failed to retrieve history data - please <a href='#'>reload</a> the page.</p>");
        return console.log("Failed to get race data back");
      });
    },
    render: function() {
      var $table;
      if (this.options.is_show_mobile_preset_dialog) {
        showMobilePresetDialog();
      }
      data = $.extend({
        runs: this.runs
      }, {
        entry: {
          can_enter: false
        },
        columns: this.columns,
        runs: this.runs,
        options: this.options
      });
      $table = $(window.HAML["history/client/templates/table"](data));
      this.$table.html($table);
      this.$table.find("select").on("focus", function() {
        return $.previous_nap_value = this.value;
      }).change(napPicksChange);
      return initTooltips($table);
    }
  };

  historyRenderer.init();

  $("#horse-history").on("click", "span.nag-me", function(event) {
    var auto_delete, button, horse_id, horse_name, horse_nationality, mode, nag_me_id, note, run_id;
    button = $(this);
    event.stopPropagation();
    note = button.data('note');
    horse_name = button.data('horse-name');
    horse_nationality = button.data('horse-nationality');
    nag_me_id = button.data("id");
    run_id = button.closest("tr").data('run-id');
    horse_id = button.data('horse-id');
    auto_delete = button.data('auto-delete');
    mode = button.hasClass('active') ? "edit" : "create";
    return show_nag_me_dialog(mode, horse_id, run_id, nag_me_id, horse_name, horse_nationality, auto_delete, note);
  });

  $(document).ready(function() {
    return $("#horse-history").stickyTableHeaders({
      fixedOffset: $('#header'),
      cacheHeaderHeight: true
    });
  });

}).call(this);
